import React, { useState, useEffect, useRef } from 'react';
import { ethers } from 'ethers';
import AvatarUploader from './AvatarUploader';
import CertificateGenerator from './CertificateGenerator';
import CircleTab from './CircleTab';
import ChangePasswordCard from './ChangePasswordCard';
import BarcodeScanner from "react-qr-barcode-scanner";
import Webcam from 'react-webcam';
import Tesseract from 'tesseract.js';
import QRCode from 'qrcode';
import './ProfilePage.css';
import { hasVault, createVault, exportBackup, unlockVault, isPasskeySupported, hasPasskey, enablePasskey, finishPasskey, unlockWithPasskey, disablePasskey } from './walletVault';
import CreateWalletModal from './CreateWalletModal';
import { prepareImage } from './imageTools';
import InfoField, { InfoFieldContext } from './InfoField';
import { prepareSend, executeSend, toBaseUnits, ASSET_DECIMALS, RELAY_URL } from './walletSend';
import { getSwapQuote, executeSwap, minOutUnits, formatUnits, quoteImpact } from './walletSwap';
import { executeMint, MINT_MIN_SOL, prepareNftTransfer, executeNftTransfer } from './walletNft';
/* global NDEFReader */

function ProfilePage({ onNavigate }) {
  const [user, setUser] = useState(null);
  const [avatarUrl, setAvatarUrl] = useState('');
  const [activeTab, setActiveTab] = useState('profile');
  const [expandedSections, setExpandedSections] = useState({
    personal: false,
    company: false,
    business: false,
    physical: false,
    professional: false,
    contact: false,
    registration: false
  });

  // Asset scanning states
  const [isScanning, setIsScanning] = useState(false);
  const [showAssetInfo, setShowAssetInfo] = useState(false);
  const [assetOwner, setAssetOwner] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [userAssets, setUserAssets] = useState([]);
  const [loadingAssets, setLoadingAssets] = useState(false);
  const [generatingCertificate, setGeneratingCertificate] = useState(null);
  const [assetFile, setAssetFile] = useState(null);

  // New asset creation states
  const [showCamera, setShowCamera] = useState(false);
  const [capturedImage, setCapturedImage] = useState(null);

  // Profile sharing states
  const [myQRCode, setMyQRCode] = useState(null);
  const [showFindUser, setShowFindUser] = useState(false);
  const [searchGenesisID, setSearchGenesisID] = useState('');
  const [foundUser, setFoundUser] = useState(null);
  const [showUserProfile, setShowUserProfile] = useState(false);
  const [nfcSupported, setNfcSupported] = useState(false);
  const [nfcScanning, setNfcScanning] = useState(false);

  // Asset menu states
  const [showAssetMenu, setShowAssetMenu] = useState(null);
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [transferGenesisID, setTransferGenesisID] = useState('');
  const [transferring, setTransferring] = useState(false);

  const [solanaBalance, setSolanaBalance] = useState('0.000');
  const [solanaAddress, setSolanaAddress] = useState('');
  const [solanaSecretKey, setSolanaSecretKey] = useState('');
  const [solanaWalletCreated, setSolanaWalletCreated] = useState(false);
    // ===== GENESIS ASSETS STATE =====
  const [walletTokens, setWalletTokens] = useState({});
  const [receiveAsset, setReceiveAsset] = useState(null);
  const [receiveQR, setReceiveQR] = useState(null);
    // ===== WALLET SECURITY STATE =====
  const [vaultProtected, setVaultProtected] = useState(false);
  const [securityModal, setSecurityModal] = useState(null); // 'protect' | 'import' | 'export'
  const [secPassword, setSecPassword] = useState('');
  const [secPassword2, setSecPassword2] = useState('');
  const [secBackupText, setSecBackupText] = useState('');
  const [secBusy, setSecBusy] = useState(false);
  const [secError, setSecError] = useState('');
  const [secShowPw, setSecShowPw] = useState(false);
    // ===== SEND STATE =====
  const [sendAsset, setSendAsset] = useState(null);
  const [sendTo, setSendTo] = useState('');
  const [sendAmount, setSendAmount] = useState('');
  const [sendPrep, setSendPrep] = useState(null);
  const [sendPassword, setSendPassword] = useState('');
  const [sendShowPw, setSendShowPw] = useState(false);
  const [sendBusy, setSendBusy] = useState(false);
  const [sendError, setSendError] = useState('');
  const [sendResult, setSendResult] = useState(null);
  // ===== SWAP STATE =====
  const [swapFrom, setSwapFrom] = useState(null);
  const [swapTo, setSwapTo] = useState('');
  const [swapAmount, setSwapAmount] = useState('');
  const [swapQuoteData, setSwapQuoteData] = useState(null);
  const [swapPassword, setSwapPassword] = useState('');
  const [swapShowPw, setSwapShowPw] = useState(false);
  const [swapAck, setSwapAck] = useState(false);
  const [swapBusy, setSwapBusy] = useState(false);
  const [swapError, setSwapError] = useState('');
  const [swapResult, setSwapResult] = useState(null);
    // ===== HISTORY STATE =====
  const [historyAsset, setHistoryAsset] = useState(null);
  const [historyItems, setHistoryItems] = useState([]);
  const [historyBusy, setHistoryBusy] = useState(false);
  const [historyError, setHistoryError] = useState('');
    // ===== WALLET UI STATE =====
  const [tokenPrices, setTokenPrices] = useState({});
  const [assetMenu, setAssetMenu] = useState(null);
  const [evmBalances, setEvmBalances] = useState({});
    // ===== FACE ID STATE =====
  const [passkeySupported, setPasskeySupported] = useState(false);
  const [passkeyOn, setPasskeyOn] = useState(false);
  const [faceIdStep, setFaceIdStep] = useState(null);
  const [showCreateWallet, setShowCreateWallet] = useState(false);
  const [attachLocation, setAttachLocation] = useState(false);
  const assetInputRef = useRef(null);
  const cameraInputRef = useRef(null);
  const [faceIdPassword, setFaceIdPassword] = useState('');
  const [faceIdShowPw, setFaceIdShowPw] = useState(false);
  const [faceIdBusy, setFaceIdBusy] = useState(false);
  const [faceIdError, setFaceIdError] = useState('');
  // NEW: NFT Mint states
const [mintingAssetId, setMintingAssetId] = useState(null);
const [mintResult, setMintResult] = useState(null);
const [mintingNft, setMintingNft] = useState(null);
const [mintAsset, setMintAsset] = useState(null);
const [mintPassword, setMintPassword] = useState('');
const [mintShowPw, setMintShowPw] = useState(false);
const [mintBusy, setMintBusy] = useState(false);
const [mintError, setMintError] = useState('');
const [mintStep, setMintStep] = useState('');
const [nftXferPrep, setNftXferPrep] = useState(null);
const [nftXferPassword, setNftXferPassword] = useState('');
const [nftXferShowPw, setNftXferShowPw] = useState(false);
const [nftXferBusy, setNftXferBusy] = useState(false);
const [nftXferError, setNftXferError] = useState('');
const [nftXferStep, setNftXferStep] = useState('');
const [nftXferAck, setNftXferAck] = useState(false);
const [certificateModal, setCertificateModal] = useState(null);

  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);
  const webcamRef = useRef(null);

// Wallet states (EVM + Solana)
const [walletAddress, setWalletAddress] = useState('');        // EVM (ETH/BSC)
const [privateKey, setPrivateKey] = useState('');              // EVM private key
const [walletCreated, setWalletCreated] = useState(false);
const [balance, setBalance] = useState(0.00);

  // API endpoints
  const API_BASE = 'https://amm8jymgmc.execute-api.us-east-1.amazonaws.com/prod';
  const CERTIFICATE_API = 'https://amm8jymgmc.execute-api.us-east-1.amazonaws.com/prod/generate-asset-certificate';
  const ASSET_LOOKUP_API = 'https://amm8jymgmc.execute-api.us-east-1.amazonaws.com/prod/lookup-asset';
  const REGISTER_ASSET_API = 'https://amm8jymgmc.execute-api.us-east-1.amazonaws.com/prod/register-asset';
  const TRANSFER_ASSET_API = 'https://amm8jymgmc.execute-api.us-east-1.amazonaws.com/prod/transfer-asset';
  const GENESIS_API = 'https://orkxz4jpah.execute-api.us-east-1.amazonaws.com';
  
  useEffect(() => {
    console.log('ProfilePage mounted, checking localStorage...');
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    console.log('Current user from localStorage:', currentUser);

    if (currentUser && currentUser.genesisID) {
      if (currentUser.expirationDate && new Date() > new Date(currentUser.expirationDate)) {
        console.log('Session expired, removing user data');
        localStorage.removeItem('currentUser');
        onNavigate('home');
      } else {
        setUser(currentUser);
        if (currentUser.walletAddress) {
          setWalletAddress(currentUser.walletAddress);
          setWalletCreated(true);
        }
// ✅ Solana wallet from profile
if (currentUser.solanaAddress) {
  setSolanaAddress(currentUser.solanaAddress);
  setSolanaWalletCreated(true);
  console.log('✅ Solana LOADED:', currentUser.solanaAddress);
}
        if (currentUser.photoUrl) {
          console.log('Setting avatar URL:', currentUser.photoUrl);
          setAvatarUrl(currentUser.photoUrl);
        }

        if (currentUser.userAssets) {
          setUserAssets(currentUser.userAssets);
          console.log('Loaded', currentUser.userAssets.length, 'assets from localStorage');
        }
        
        loadUserAssets(currentUser.genesisID);
      }
    } else {
      console.log('No valid user found, redirecting to home');
      onNavigate('home');
    }

// Check NFC support
// eslint-disable-next-line no-undef
if (typeof NDEFReader !== 'undefined') {
      setNfcSupported(true);
      console.log('NFC supported');
    } else {
      console.log('NFC not supported');
    }
  }, [onNavigate]);

  useEffect(() => {
    if (walletAddress) {
      fetchBalance();
      const interval = setInterval(fetchBalance, 10000);
      return () => clearInterval(interval);
    }
  }, [walletAddress]);



  // Wallet functions
  const generateWallet = async () => {
    const wallet = ethers.Wallet.createRandom();
    setWalletAddress(wallet.address);
    setPrivateKey(wallet.privateKey);
    setWalletCreated(true);
    
    const downloadBackupDirect = (w) => {
      const data = `Genesis Wallet Backup\n\nWallet Address: ${w.address}\n\nPrivate Key: ${w.privateKey}\n\n⚠️ KEEP THIS SAFE!`;
      const blob = new Blob([data], { type: 'text/plain' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `genesis-wallet-${w.address.slice(0, 8)}.txt`;
      a.click();
      console.log('✅ Backup downloaded!');
    };
    
    downloadBackupDirect(wallet);
    
    try {
      const response = await fetch('https://orkxz4jpah.execute-api.us-east-1.amazonaws.com/update-profile', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          genesisID: user.genesisID,
          walletAddress: wallet.address
        })
      });

      const result = await response.json();
      console.log('✅ Wallet save response:', result);
      
      if (result.success) {
        const updatedUser = { ...user, walletAddress: wallet.address };
        setUser(updatedUser);
        localStorage.setItem('currentUser', JSON.stringify(updatedUser));
        alert('Wallet created and saved!');
      } else {
        alert('Wallet created locally only: ' + (result.error || 'Unknown error'));
      }
    } catch (error) {
      console.error('❌ Failed to save wallet:', error);
      alert('Wallet created locally only. Server error.');
    }
  };

  const downloadBackup = () => {
    const data = `Genesis Wallet Backup\n\nAddress: ${walletAddress}\nPrivate Key: ${privateKey}\n\nKEEP THIS SAFE!`;
    const blob = new Blob([data], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `genesis-wallet-${walletAddress.slice(0,8)}.txt`;
    a.click();
    console.log('✅ Backup downloaded with private key!');
  };

  const fetchBalance = async () => {
    if (!walletAddress) return;
    
    try {
      const networks = [
        { name: 'ETH', rpc: 'https://mainnet.infura.io/v3/b6fd42ee6ac44444a0291b00ca6735e4' },
        { name: 'BSC', rpc: 'https://bsc-dataseed1.binance.org' }
      ];

      let totalBalance = 0;
      const perNet = {};
      for (const network of networks) {
        const provider = new ethers.JsonRpcProvider(network.rpc);
        const balanceWei = await provider.getBalance(walletAddress);
        const bal = parseFloat(ethers.formatEther(balanceWei));
        totalBalance += bal;
        perNet[network.name] = bal.toFixed(6);
        if (bal > 0) console.log(`💰 ${network.name}:`, bal);
      }
      
      setBalance(totalBalance.toFixed(6));
      setEvmBalances(perNet);
    } catch (error) {
      console.error('❌ Error:', error);
    }
  };

// --- Solana Wallet Logic (Combined: Local Keygen + API Balance) ---

  const fetchSolanaBalance = async (addressOverride) => {
    const addr = addressOverride || solanaAddress;
    if (!addr) return;
    
    try {
      const response = await fetch(`${GENESIS_API}/get-solana-balance`, { 
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          genesisID: user.genesisID,
          solanaAddress: addr 
        })
      });
      const data = await response.json();
      if (data.success) {
        setSolanaBalance(data.balance);
        if (data.tokens) setWalletTokens(data.tokens);
      }
    } catch (error) {
      console.error('Error fetching Solana balance:', error);
    }
  };

  const handleWalletCreated = (address) => {
    setShowCreateWallet(false);
    setSolanaAddress(address);
    setSolanaWalletCreated(true);
    setVaultProtected(true);
    const updatedUser = { ...user, solanaAddress: address };
    setUser(updatedUser);
    localStorage.setItem('currentUser', JSON.stringify(updatedUser));
    fetchSolanaBalance(address);
    if (passkeySupported) setFaceIdStep('password'); // одразу пропонуємо Face ID
  };
  useEffect(() => {
    if (solanaAddress) {
      fetchSolanaBalance();
      const interval = setInterval(fetchSolanaBalance, 30000);
      return () => clearInterval(interval);
    }
  }, [solanaAddress]);

    // ===== GENESIS ASSETS ACTIONS =====
  const openReceive = async (symbol) => {
    if (!solanaAddress) return;
    const qr = await QRCode.toDataURL(solanaAddress, { width: 220, margin: 2 });
    setReceiveAsset(symbol);
    setReceiveQR(qr);
  };

  const comingSoon = (action, symbol) => alert(`${action} ${symbol} — coming soon`);
  // ===== END GENESIS ASSETS ACTIONS =====

  // ===== WALLET SECURITY ACTIONS =====
  useEffect(() => {
    if (solanaAddress) setVaultProtected(hasVault(solanaAddress));
  }, [solanaAddress]);

  const closeSecurityModal = () => {
    setSecurityModal(null);
    setSecPassword('');
    setSecPassword2('');
    setSecBackupText('');
    setSecShowPw(false);
    setSecError('');
  };

  const handleBackupFile = async (e) => {
    const f = e.target.files?.[0];
    if (f) setSecBackupText(await f.text());
  };

  const handleProtectOrImport = async () => {
    setSecError('');
    if (secPassword !== secPassword2) { setSecError('Passwords do not match'); return; }
    const source = securityModal === 'protect' ? user?.solanaSecretKey : secBackupText;
    if (!source) { setSecError('No key found'); return; }
    setSecBusy(true);
    try {
      await createVault(source, secPassword, solanaAddress);
      // Відкриту копію прибираємо ТІЛЬКИ після успішної перевірки сховища
      if (user?.solanaSecretKey) {
        const cleanUser = { ...user };
        delete cleanUser.solanaSecretKey;
        setUser(cleanUser);
        localStorage.setItem('currentUser', JSON.stringify(cleanUser));
      }
      setSolanaSecretKey('');
      setVaultProtected(true);
      closeSecurityModal();
      alert('✅ Wallet protected with password');
    } catch (e) {
      setSecError(e.message);
    } finally {
      setSecBusy(false);
    }
  };

  const handleExportBackup = async () => {
    setSecError('');
    setSecBusy(true);
    try {
      await exportBackup(solanaAddress, secPassword);
      closeSecurityModal();
    } catch (e) {
      setSecError(e.message);
    } finally {
      setSecBusy(false);
    }
  };
  // ===== END WALLET SECURITY ACTIONS =====
  
  // ===== SEND ACTIONS =====
  const assetBalance = (symbol) => (symbol === 'SOL' ? solanaBalance : walletTokens[symbol]?.balance) || '0';
  const toUnitsSafe = (v, d) => { try { return toBaseUnits(v, d); } catch { return 0n; } };

  const openSend = (symbol) => {
    if (!vaultProtected) { alert('Protect your wallet with a password first (Security section below).'); return; }
    setSendAsset(symbol); setSendTo(''); setSendAmount(''); setSendPrep(null);
    setSendPassword(''); setSendShowPw(false); setSendError(''); setSendResult(null);
  };

  const closeSend = () => {
    const wasSent = !!sendResult;
    setSendAsset(null); setSendPrep(null); setSendPassword(''); setSendError(''); setSendResult(null);
    if (wasSent) fetchSolanaBalance();
  };

  const setMaxAmount = () => {
    if (sendAsset === 'SOL') setSendAmount(Math.max(0, parseFloat(solanaBalance) - 0.003).toFixed(6));
    else setSendAmount(assetBalance(sendAsset));
  };

  const handleSendNext = async () => {
    setSendError('');
    try {
      const units = toBaseUnits(sendAmount, ASSET_DECIMALS[sendAsset]);
      if (sendAsset === 'SOL') {
        if (parseFloat(sendAmount) + 0.00001 > parseFloat(solanaBalance)) throw new Error('Not enough SOL (keep some for the network fee)');
      } else {
        if (units > toUnitsSafe(assetBalance(sendAsset), ASSET_DECIMALS[sendAsset])) throw new Error(`Not enough ${sendAsset}`);
        if (parseFloat(solanaBalance) < 0.0001) throw new Error('Not enough SOL for the network fee');
      }
      setSendBusy(true);
      const prep = await prepareSend({ asset: sendAsset, recipient: sendTo.trim(), fromGenesisID: user.genesisID, fromAddress: solanaAddress });
      if (prep.needsAccount && parseFloat(solanaBalance) < 0.0022) {
        throw new Error('Not enough SOL: the recipient needs a token account (~0.00204 SOL)');
      }
      setSendPrep(prep);
    } catch (e) {
      setSendError(e.message);
    } finally {
      setSendBusy(false);
    }
  };

  const handleSendConfirm = async () => {
    setSendError('');
    setSendBusy(true);
    try {
      const res = await executeSend({
        asset: sendAsset, recipient: sendTo.trim(), amount: sendAmount, password: sendPassword,
        fromGenesisID: user.genesisID, fromAddress: solanaAddress, expectedRecipientAddress: sendPrep.recipientAddress,
      });
      setSendResult(res);
      setSendPassword('');
    } catch (e) {
      setSendError(e.signature ? `${e.message} (tx: ${e.signature.slice(0, 10)}…)` : e.message);
    } finally {
      setSendBusy(false);
    }
  };
  // ===== END SEND ACTIONS =====
  
  // ===== SWAP ACTIONS =====
  const SWAP_ASSETS = ['SOL', 'THEO', 'USDC', 'USDT'];
  const impactColor = (p) => (p === null ? '#666' : p < 1 ? '#16a34a' : p < 5 ? '#ca8a04' : '#dc2626');

  const openSwap = (symbol) => {
    if (!vaultProtected) { alert('Protect your wallet with a password first (Security section below).'); return; }
    setSwapFrom(symbol);
    setSwapTo(symbol === 'THEO' ? 'USDC' : 'THEO');
    setSwapAmount(''); setSwapQuoteData(null); setSwapPassword(''); setSwapShowPw(false);
    setSwapAck(false); setSwapError(''); setSwapResult(null);
  };

  const closeSwap = () => {
    const wasSwapped = !!swapResult;
    setSwapFrom(null); setSwapQuoteData(null); setSwapPassword(''); setSwapError(''); setSwapResult(null);
    if (wasSwapped) fetchSolanaBalance();
  };

  const setSwapMax = () => {
    if (swapFrom === 'SOL') setSwapAmount(Math.max(0, parseFloat(solanaBalance) - 0.01).toFixed(6));
    else setSwapAmount(assetBalance(swapFrom));
  };

  const handleSwapQuote = async () => {
    setSwapError('');
    try {
      const amt = swapAmount.trim().replace(',', '.');
      const units = toBaseUnits(amt, ASSET_DECIMALS[swapFrom]);
      if (swapFrom === 'SOL') {
        if (parseFloat(amt) + 0.01 > parseFloat(solanaBalance)) throw new Error('Not enough SOL (keep 0.01 SOL for fees)');
      } else {
        if (units > toUnitsSafe(assetBalance(swapFrom), ASSET_DECIMALS[swapFrom])) throw new Error(`Not enough ${swapFrom}`);
        if (parseFloat(solanaBalance) < 0.005) throw new Error('Not enough SOL for network fees (need ~0.005 SOL)');
      }
      setSwapBusy(true);
      const q = await getSwapQuote({ inputAsset: swapFrom, outputAsset: swapTo, amount: amt });
      if (!q.outAmount) throw new Error(q.errorMessage || 'No route found for this pair');
      setSwapAck(false);
      setSwapQuoteData(q);
    } catch (e) {
      setSwapError(e.message);
    } finally {
      setSwapBusy(false);
    }
  };

  const handleSwapConfirm = async () => {
    setSwapError('');
    setSwapBusy(true);
    try {
      const res = await executeSwap({
        inputAsset: swapFrom, outputAsset: swapTo, amount: swapQuoteData.inAmount,
        password: swapPassword, fromAddress: solanaAddress, shownQuote: swapQuoteData,
      });
      setSwapResult(res);
      setSwapPassword('');
    } catch (e) {
      setSwapError(e.message);
    } finally {
      setSwapBusy(false);
    }
  };
  // ===== END SWAP ACTIONS =====
  
  // ===== HISTORY ACTIONS =====
  const openHistory = async (symbol) => {
    setHistoryAsset(symbol); setHistoryItems([]); setHistoryError(''); setHistoryBusy(true);
    try {
      const res = await fetch(RELAY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'history', address: solanaAddress }),
      });
      const data = await res.json();
      if (!data.success) throw new Error(data.error || 'Failed to load history');
      setHistoryItems(data.items || []);
    } catch (e) {
      setHistoryError(e.message);
    } finally {
      setHistoryBusy(false);
    }
  };

  const closeHistory = () => { setHistoryAsset(null); setHistoryItems([]); setHistoryError(''); };
  const shortAddr = (a) => (a ? `${a.slice(0, 4)}…${a.slice(-4)}` : '');
  const fmtAmount = (s) => {
    const n = parseFloat(s);
    return `${n > 0 ? '+' : ''}${n.toLocaleString('en-US', { maximumFractionDigits: 6 })}`;
  };
  // ===== END HISTORY ACTIONS =====
  
  // ===== PRICES & ASSET LIST =====
  const fetchPrices = async () => {
    try {
      const res = await fetch(RELAY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'prices' }),
      });
      const data = await res.json();
      if (data.success) setTokenPrices(data.prices || {});
    } catch (e) {
      console.error('prices error:', e);
    }
  };

  useEffect(() => {
    if (!solanaAddress) return;
    fetchPrices();
    const t = setInterval(fetchPrices, 60000);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [solanaAddress]);

  const refreshWallet = () => { fetchSolanaBalance(); fetchPrices(); };
  const usd = (n) => n.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const walletAssetList = () => [
    { symbol: 'SOL', name: 'Solana', balance: solanaBalance, color: '#9945FF', logo: '/tokens/sol.png' },
    { symbol: 'THEO', name: 'TheoKoin', balance: walletTokens.THEO?.balance, color: '#b8860b', logo: '/tokens/theo.png' },
    { symbol: 'USDC', name: 'USD Coin', balance: walletTokens.USDC?.balance, color: '#2775CA', logo: '/tokens/usdc.png' },
    { symbol: 'USDT', name: 'Tether USD', balance: walletTokens.USDT?.balance, color: '#26A17B', logo: '/tokens/usdt.svg' },
  ];

  const assetLogo = (a, size) => (
    <>
      <img src={a.logo} alt={a.symbol}
        style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
        onError={(e) => { e.currentTarget.style.display = 'none'; e.currentTarget.nextSibling.style.display = 'flex'; }} />
      <div style={{ width: size, height: size, borderRadius: '50%', background: a.color, color: '#fff', display: 'none', alignItems: 'center', justifyContent: 'center', fontWeight: 700, flexShrink: 0 }}>
        {a.symbol.slice(0, 1)}
      </div>
    </>
  );
  // ===== END PRICES & ASSET LIST =====
  
  // ===== FACE ID ACTIONS =====
  useEffect(() => {
    isPasskeySupported().then(setPasskeySupported);
  }, []);

  useEffect(() => {
    if (solanaAddress) setPasskeyOn(hasPasskey(solanaAddress));
  }, [solanaAddress, vaultProtected]);

  const closeFaceId = () => {
    setFaceIdStep(null); setFaceIdPassword(''); setFaceIdShowPw(false); setFaceIdError('');
  };

  const faceIdDone = () => {
    setPasskeyOn(true);
    closeFaceId();
    alert('✅ Face ID / fingerprint enabled for this wallet on this device');
  };

  // Крок 1: перевірка пароля (до Face ID)
  const handleFaceIdPassword = async () => {
    setFaceIdError(''); setFaceIdBusy(true);
    try {
      await unlockVault(solanaAddress, faceIdPassword);
      setFaceIdStep('create');
    } catch (e) {
      setFaceIdError(e.message);
    } finally {
      setFaceIdBusy(false);
    }
  };

  // Крок 2: Face ID одразу по натисканню
  const handleFaceIdCreate = async () => {
    setFaceIdError(''); setFaceIdBusy(true);
    try {
      const r = await enablePasskey(solanaAddress, faceIdPassword);
      if (r === 'pending') setFaceIdStep('finish');
      else faceIdDone();
    } catch (e) {
      setFaceIdError(e.message);
    } finally {
      setFaceIdBusy(false);
    }
  };

  // Крок 3 (лише iPhone): друге підтвердження
  const handleFaceIdFinish = async () => {
    setFaceIdError(''); setFaceIdBusy(true);
    try {
      await finishPasskey(solanaAddress, faceIdPassword);
      faceIdDone();
    } catch (e) {
      setFaceIdError(e.message);
    } finally {
      setFaceIdBusy(false);
    }
  };

  const handleDisableFaceId = () => {
    if (!window.confirm('Turn off Face ID for this wallet on this device? Your password will keep working.')) return;
    disablePasskey(solanaAddress);
    setPasskeyOn(false);
  };

  const handleSendFaceId = async () => {
    setSendError(''); setSendBusy(true);
    try {
      const keypair = await unlockWithPasskey(solanaAddress);
      const res = await executeSend({
        asset: sendAsset, recipient: sendTo.trim(), amount: sendAmount, keypair,
        fromGenesisID: user.genesisID, fromAddress: solanaAddress, expectedRecipientAddress: sendPrep.recipientAddress,
      });
      setSendResult(res);
      setSendPassword('');
    } catch (e) {
      setSendError(e.signature ? `${e.message} (tx: ${e.signature.slice(0, 10)}…)` : e.message);
    } finally {
      setSendBusy(false);
    }
  };

  const handleSwapFaceId = async () => {
    setSwapError(''); setSwapBusy(true);
    try {
      const keypair = await unlockWithPasskey(solanaAddress);
      const res = await executeSwap({
        inputAsset: swapFrom, outputAsset: swapTo, amount: swapQuoteData.inAmount, keypair,
        fromAddress: solanaAddress, shownQuote: swapQuoteData,
      });
      setSwapResult(res);
      setSwapPassword('');
    } catch (e) {
      setSwapError(e.message);
    } finally {
      setSwapBusy(false);
    }
  };
  // ===== END FACE ID ACTIONS =====
  const loadUserAssets = async (genesisID) => {
    setLoadingAssets(true);
    try {
      const response = await fetch(`${API_BASE}/get-user-assets`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ genesisID })
      });

      const result = await response.json();
      if (result.success) {
        setUserAssets(result.assets);
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        const updatedUser = { ...currentUser, userAssets: result.assets };
        setUser(updatedUser);
        localStorage.setItem('currentUser', JSON.stringify(updatedUser));
        console.log('Loaded', result.assets?.length || 0, 'assets from database');
      } else {
        console.error('Failed to load assets:', result.error);
      }
    } catch (error) {
      console.error('Error loading assets:', error);
    } finally {
      setLoadingAssets(false);
    }
  };

  const lookupAsset = async (assetCode) => {
    try {
      const response = await fetch(ASSET_LOOKUP_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ assetCode })
      });
      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Asset lookup error:', error);
      return { success: false, error: error.message };
    }
  };

  const registerNewAsset = async (assetCode, qrData = null) => {
    if (!assetCode || uploading) return;
    setUploading(true);

    try {
      const response = await fetch(REGISTER_ASSET_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          assetCode,
          qrData,
          ownerGenesisID: user.genesisID,
          ownerName: `${user.firstName} ${user.lastName}`,
          timestamp: new Date().toISOString()
        })
      });

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Asset registration error:', error);
      return { success: false, error: error.message };
    } finally {
      setUploading(false);
    }
  };

  const performOCR = async (imageFile) => {
    try {
      const result = await Tesseract.recognize(imageFile, 'eng', {
        logger: m => console.log(m)
      });
      const codeMatch = result.data.text.match(/[A-Za-z0-9]{6,7}/);
      if (codeMatch) {
        return codeMatch[0];
      }
      return null;
    } catch (error) {
      console.error('OCR Error:', error);
      return null;
    }
  };

  const handleQRScan = async (qrData) => {
    console.log('QR Data scanned:', qrData);

    try {
      const parsedData = JSON.parse(qrData);

      if (parsedData.type === 'genesiscertificate') {
        window.open(parsedData.url, '_blank');
        stopQRScanning();
        return;
      }

      if (parsedData.type === 'genesisprofile') {
        const foundUser = {
          genesisID: parsedData.genesisID,
          firstName: parsedData.name?.split(' ')[0] || 'Unknown',
          lastName: parsedData.name?.split(' ')[1] || '',
          email: parsedData.email
        };
        setFoundUser(foundUser);
        setShowUserProfile(true);
        stopQRScanning();
        return;
      }
    } catch (e) {
      // Not JSON, treat as asset code
    }

    const lookupResult = await lookupAsset(qrData);

    if (lookupResult.success && lookupResult.asset) {
      setAssetOwner(lookupResult.asset);
      setShowAssetInfo(true);
    } else {
      const registerResult = await registerNewAsset(qrData, qrData);
      if (registerResult.success) {
        alert(`New asset registered! Code: ${qrData}`);
        loadUserAssets(user.genesisID);
      } else {
        alert(`Asset registration failed: ${registerResult.error}`);
      }
    }
    stopQRScanning();
  };

  const handleOCRScan = async () => {
    if (uploading) return;

    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    fileInput.capture = 'camera';
    fileInput.onchange = async (e) => {
      const file = e.target.files[0];
      if (file) {
        console.log('OCR processing file:', file.name);
        setUploading(true);

        const detectedCode = await performOCR(file);
        console.log('OCR detected code:', detectedCode);

        if (detectedCode) {
          const lookupResult = await lookupAsset(detectedCode);

          if (lookupResult.success && lookupResult.asset) {
            console.log('Asset found, showing owner info');
            setAssetOwner(lookupResult.asset);
            setShowAssetInfo(true);
          } else {
            console.log('Asset not found, registering new');
            const registerResult = await registerNewAsset(detectedCode);
            if (registerResult.success) {
              alert(`New asset registered! Code: ${detectedCode}`);
              loadUserAssets(user.genesisID);
            } else {
              alert(`Registration failed: ${registerResult.error}`);
            }
          }
        } else {
          alert('Code not recognized. Try better lighting or clearer image.');
        }
        setUploading(false);
      }
    };
    fileInput.click();
  };

  const generateMyQRCode = async () => {
    try {
      console.log('Getting certificate URL from genesis-assets-api...');
      
      const response = await fetch('https://amm8jymgmc.execute-api.us-east-1.amazonaws.com/prod/get-user-certificate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ genesisID: user.genesisID })
      });

      const data = await response.json();
      console.log('Response from API:', data);

      if (!data.success || !data.certificateUrl) {
        alert('Certificate not found! Please generate certificate first.');
        return;
      }

      console.log('Certificate URL from DB:', data.certificateUrl);

      const qrData = JSON.stringify({
        type: 'genesiscertificate',
        url: data.certificateUrl,
        genesisID: user.genesisID,
        name: `${user.firstName} ${user.lastName}`,
        timestamp: new Date().toISOString()
      });

      const qrCodeUrl = await QRCode.toDataURL(qrData, {
        width: 200,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#FFFFFF'
        }
      });

      setMyQRCode(qrCodeUrl);
      console.log('QR Code with certificate URL generated!');
    } catch (error) {
      console.error('Error generating QR code:', error);
      alert('Error generating QR code: ' + error.message);
    }
  };

  const downloadQRCode = () => {
    if (!myQRCode) return;
    const link = document.createElement('a');
    link.href = myQRCode;
    link.download = `Genesis-QR-${user.genesisID}-${user.firstName}${user.lastName}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    console.log('QR Code downloaded successfully!');
  };

  const startNFCShare = async () => {
    if (!nfcSupported) {
      alert('NFC not supported on this device');
      return;
    }

try {
  // eslint-disable-next-line no-undef
  const ndef = new NDEFReader();
      const nfcData = JSON.stringify({
        type: 'genesisprofile',
        genesisID: user.genesisID,
        name: `${user.firstName} ${user.lastName}`,
        email: user.email,
        timestamp: new Date().toISOString()
      });

      await ndef.write({
        records: [{ recordType: "text", data: nfcData }]
      });
      alert('Ready to share via NFC. Tap devices together.');
    } catch (error) {
      console.error('NFC Error:', error);
      alert('NFC sharing failed: ' + error.message);
    } finally {
      setUploading(false);
    }
  };

  const startNFCScanning = async () => {
    if (!nfcSupported) {
      alert('NFC not supported on this device');
      return;
    }

    try {
      const ndef = new NDEFReader();
      await ndef.scan();
      setNfcScanning(true);

      ndef.addEventListener("reading", ({ message }) => {
        console.log('NFC message received:', message);
        for (const record of message.records) {
          if (record.recordType === "text") {
            const textDecoder = new TextDecoder(record.encoding);
            const data = textDecoder.decode(record.data);
            console.log('NFC data:', data);

            try {
              const parsedData = JSON.parse(data);
              if (parsedData.type === 'genesisprofile') {
                const foundUser = {
                  genesisID: parsedData.genesisID,
                  firstName: parsedData.name?.split(' ')[0] || 'Unknown',
                  lastName: parsedData.name?.split(' ')[1] || '',
                  email: parsedData.email
                };
                setFoundUser(foundUser);
                setShowUserProfile(true);
              }
            } catch (e) {
              alert('NFC data received: ' + data);
            }
            setNfcScanning(false);
          }
        }
      });

      ndef.addEventListener("readingerror", () => {
        alert('NFC reading error. Try again.');
        setNfcScanning(false);
      });

      alert('NFC scanning started. Tap an NFC device.');
    } catch (error) {
      console.error('NFC Error:', error);
      alert('NFC scanning failed: ' + error.message);
      setNfcScanning(false);
    }
  };

  const showFindUserDialog = () => {
    setShowFindUser(true);
    setSearchGenesisID('');
  };

  const searchUserByID = async () => {
    if (!searchGenesisID.trim()) return;

    setUploading(true);

    setTimeout(() => {
      if (searchGenesisID.trim() === '1234567') {
        const mockUser = {
          genesisID: '1234567',
          firstName: 'Test',
          lastName: 'User',
          email: 'test@example.com',
          location: 'Test City',
          personalQuote: 'This is a test user',
          registrationDate: '2024-01-01'
        };
        setFoundUser(mockUser);
        setShowUserProfile(true);
        setShowFindUser(false);
      } else {
        alert(`User not found with Genesis ID: ${searchGenesisID}. Try 1234567 for test`);
      }
      setUploading(false);
    }, 1000);
  };

  const captureNewAssetPhoto = () => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      setCapturedImage(imageSrc);
    }
  };

  const startNewAssetCamera = () => {
    setShowCamera(true);
    setCapturedImage(null);
  };

  const uploadCapturedAsset = async () => {
    if (!capturedImage || uploading) return;
    setUploading(true);
    try {
      const location = attachLocation ? await getUserLocation() : null;
      const blob = await (await fetch(capturedImage)).blob();
      await uploadAsset(blob, 'photoasset', null, location);
      setCapturedImage(null);
      setShowCamera(false);
      alert('✅ New asset created');
    } catch (error) {
      console.error('Error creating asset:', error);
      alert('❌ ' + error.message); // фото лишається на екрані — можна повторити
    } finally {
      setUploading(false);
    }
  };
  // Рідна камера телефона (повна якість, автофокус)
  const handleNativeCapture = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file || uploading) return;
    setUploading(true);
    try {
      const location = attachLocation ? await getUserLocation() : null;
      await uploadAsset(file, 'photoasset', null, location);
      alert('✅ New asset created');
    } catch (error) {
      console.error('Error creating asset:', error);
      alert('❌ ' + error.message);
    } finally {
      setUploading(false);
    }
  };
const cancelAssetCreation = () => {
  setCapturedImage(null);
  setShowCamera(false);
};

const generateAssetCertificate = async (assetId) => {
  console.log('Generating certificate for asset:', assetId);
  setGeneratingCertificate(assetId);
  try {
    const response = await fetch(CERTIFICATE_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ assetId, genesisID: user.genesisID })
    });
    const result = await response.json();
    if (result.success) {
      const cert = result.certificate;
      setCertificateModal({
        url: cert.url,
        assetId: cert.assetId,
        fromCache: cert.fromCache,
        solanaTxHash: cert.solanaTxHash,
        explorerUrl: cert.explorerUrl,
        ipfsCid: cert.ipfsCid,
        fileHash: cert.fileHash,
        generatedAt: cert.generatedAt
      });
      // Оновлюємо asset в списку
      const updatedAssets = userAssets.map(a =>
        a.assetId === assetId
          ? { ...a, certificateUrl: cert.url, solanaTxHash: cert.solanaTxHash }
          : a
      );
      setUserAssets(updatedAssets);
      const updatedUser = { ...user, userAssets: updatedAssets };
      setUser(updatedUser);
      localStorage.setItem('currentUser', JSON.stringify(updatedUser));
    } else {
      alert('Failed to generate certificate: ' + result.error);
    }
  } catch (error) {
    console.error('Certificate generation error:', error);
    alert('Error generating certificate: ' + error.message);
  } finally {
    setGeneratingCertificate(null);
  }
};
  const getUserLocation = () => {
    return new Promise((resolve) => {
      if (!navigator.geolocation) {
        console.log('Geolocation not supported');
        resolve(null);
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log('Location obtained:', position.coords.latitude, position.coords.longitude);
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            accuracy: position.coords.accuracy
          });
        },
        (error) => {
          console.log('Location error:', error.message);
          resolve(null);
        },
        { timeout: 10000 }
      );
    });
  };

  const startQRScanning = async () => {
    console.log('Starting QR scan');
    setIsScanning(true);
  };

  const stopQRScanning = () => {
    console.log('Stopping QR scan');
    setIsScanning(false);
  };

  const handleAssetUpload = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setAssetFile(selectedFile);
      console.log('File selected for upload:', selectedFile.name);
    }
  };

  const uploadSelectedAsset = async () => {
    if (!assetFile || uploading) return;
    setUploading(true);
    try {
      const location = attachLocation ? await getUserLocation() : null;
      await uploadAsset(assetFile, 'photoupload', null, location);
      setAssetFile(null);
      if (assetInputRef.current) assetInputRef.current.value = '';
      alert('✅ Asset saved');
    } catch (error) {
      console.error('Error uploading asset:', error);
      alert('❌ ' + error.message);
    } finally {
      setUploading(false);
    }
  };

  const uploadAsset = async (file, type, qrData = null, location = null) => {
    if (!user?.genesisID) throw new Error('Session expired. Please log in again.');

    // JPEG, правильний поворот, без EXIF/GPS, до 4 МБ, + SHA-256
    const prepared = await prepareImage(file, { baseName: type === 'photoasset' ? `asset-${Date.now()}` : undefined });

    const formData = new FormData();
    formData.append('file', prepared.file);
    formData.append('genesisID', user.genesisID);
    formData.append('type', type);
    if (qrData) formData.append('qrData', qrData);

    const uploadResponse = await fetch(`${API_BASE}/upload-asset`, { method: 'POST', body: formData });
    const uploadResult = await uploadResponse.json().catch(() => ({}));
    if (!uploadResponse.ok || !uploadResult.success) {
      throw new Error(uploadResult.error || uploadResult.message || 'Upload failed. Please try again.');
    }

    const saveResponse = await fetch(`${API_BASE}/save-asset`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        genesisID: user.genesisID,
        type,
        qrData,
        imageUrl: uploadResult.imageUrl,
        title: type === 'qrscan' ? 'QR Scan' : type === 'photoasset' ? 'Genesis Asset' : `Photo Upload - ${new Date().toLocaleDateString()}`,
        fileInfo: {
          ...uploadResult.fileInfo,
          originalName: prepared.originalName,
          width: prepared.width,
          height: prepared.height,
          sha256: prepared.sha256,
        },
        location
      })
    });
    const saveResult = await saveResponse.json().catch(() => ({}));
    if (!saveResult.success) throw new Error(saveResult.error || 'Save failed. Please try again.');

    const updatedAssets = [...userAssets, saveResult.asset];
    setUserAssets(updatedAssets);
    const updatedUser = { ...user, userAssets: updatedAssets };
    setUser(updatedUser);
    localStorage.setItem('currentUser', JSON.stringify(updatedUser));
    return saveResult.asset;
  };
  
  const transferAsset = async () => {
    if (!transferGenesisID.trim() || !selectedAsset) {
      alert('Please enter a valid Genesis ID');
      return;
    }

    if (transferGenesisID === user.genesisID) {
      alert('Cannot transfer to yourself');
      return;
    }

    setTransferring(true);

    try {
      const response = await fetch(TRANSFER_ASSET_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          assetId: selectedAsset.assetId,
          fromGenesisID: user.genesisID,
          toGenesisID: transferGenesisID.trim()
        })
      });

      const result = await response.json();

if (result.success) {
  const txInfo = result.solanaTxHash && result.solanaTxHash !== 'pending'
    ? `\n\nSolana TX: ${result.solanaTxHash.substring(0, 20)}...`
    : '';
  alert(`✅ Asset transferred to ${result.toName}!${txInfo}`);
        
        const updatedAssets = userAssets.filter(a => a.assetId !== selectedAsset.assetId);
        setUserAssets(updatedAssets);
        
        const updatedUser = { ...user, userAssets: updatedAssets };
        setUser(updatedUser);
        localStorage.setItem('currentUser', JSON.stringify(updatedUser));
        
        setShowTransferModal(false);
        setSelectedAsset(null);
        setTransferGenesisID('');
      } else {
        alert('Transfer failed: ' + result.message);
      }
    } catch (error) {
      console.error('Transfer error:', error);
      alert('Error transferring asset: ' + error.message);
    } finally {
      setTransferring(false);
    }
  };

  // ===== TRANSFER: закриття модалки + переказ NFT через TheoWallet =====
  const resetTransfer = () => {
    setShowTransferModal(false); setSelectedAsset(null); setTransferGenesisID('');
    setNftXferPrep(null); setNftXferPassword(''); setNftXferShowPw(false); setNftXferError(''); setNftXferStep('');
  };
  const closeTransfer = () => { if (!nftXferBusy && !transferring) resetTransfer(); };

  // Крок 1: перевірка отримувача (без підпису)
  const handleNftTransferPrepare = async () => {
    setNftXferError('');
    if (!solanaAddress || !vaultProtected) { setNftXferError('Protect your TheoWallet with a password first (Security section).'); return; }
    setNftXferBusy(true);
    try {
      const prep = await prepareNftTransfer({ assetId: selectedAsset.assetId, fromGenesisID: user.genesisID, recipient: transferGenesisID.trim() });
      const need = prep.needsAccount ? 0.0025 : 0.0005;
      if (parseFloat(solanaBalance) < need) throw new Error(`Not enough SOL for the transfer (need ~${need} SOL)`);
      if (prep.alreadyTransferred) {
        const updatedAssets = userAssets.filter((a) => a.assetId !== selectedAsset.assetId);
        setUserAssets(updatedAssets);
        const updatedUser = { ...user, userAssets: updatedAssets };
        setUser(updatedUser);
        localStorage.setItem('currentUser', JSON.stringify(updatedUser));
        alert(`✅ This NFT was already sent to ${prep.toGenesisID ? `${prep.toName} (Genesis ID ${prep.toGenesisID})` : 'an external Solana wallet'}`);
        setNftXferBusy(false);
        resetTransfer();
        return;
      }
      setNftXferPrep(prep); setNftXferAck(false);
    } catch (e) {
      setNftXferError(e.message);
    } finally {
      setNftXferBusy(false);
    }
  };

  // Крок 2: пароль / Face ID -> підпис у браузері -> мережа -> chain of custody
  const handleNftTransferConfirm = async (useFaceId) => {
    setNftXferError(''); setNftXferBusy(true);
    try {
      const keypair = useFaceId ? await unlockWithPasskey(solanaAddress) : null;
      const res = await executeNftTransfer({
        assetId: selectedAsset.assetId, fromGenesisID: user.genesisID, recipient: transferGenesisID.trim(),
        fromAddress: solanaAddress, password: nftXferPassword, keypair,
        expectedToWallet: nftXferPrep.toWallet, onStep: setNftXferStep,
      });
      const updatedAssets = userAssets.filter((a) => a.assetId !== selectedAsset.assetId);
      setUserAssets(updatedAssets);
      const updatedUser = { ...user, userAssets: updatedAssets };
      setUser(updatedUser);
      localStorage.setItem('currentUser', JSON.stringify(updatedUser));
      fetchSolanaBalance();
      alert(`✅ NFT sent to ${res.toGenesisID ? `${res.toName} (Genesis ID ${res.toGenesisID})` : 'an external Solana wallet'}`);
      setNftXferBusy(false);
      resetTransfer();
    } catch (e) {
      setNftXferError(e.signature ? `${e.message} (tx: ${e.signature.slice(0, 10)}…)` : e.message);
      setNftXferBusy(false);
    } finally {
      setNftXferStep('');
    }
  };
  // ===== END TRANSFER =====

  // ===== MINT NFT через TheoWallet (приватний ключ не покидає браузер) =====
  const mintNFT = (asset) => {
    if (!solanaAddress) { alert('Create your TheoWallet first (TheoWallet tab).'); return; }
    if (!vaultProtected) { alert('Protect your wallet with a password first (Security section below).'); return; }
    setMintAsset(asset); setMintPassword(''); setMintShowPw(false); setMintError(''); setMintStep('');
  };

  const closeMint = () => {
    if (mintBusy) return;
    setMintAsset(null); setMintPassword(''); setMintError(''); setMintStep('');
  };

  const runMint = async (useFaceId) => {
    setMintError(''); setMintBusy(true); setMintingNft(mintAsset.assetId);
    try {
      const keypair = useFaceId ? await unlockWithPasskey(solanaAddress) : null;
      const res = await executeMint({
        assetId: mintAsset.assetId, genesisID: user.genesisID, fromAddress: solanaAddress,
        password: mintPassword, keypair, onStep: setMintStep,
        balanceSol: parseFloat(solanaBalance),
      });
      const updatedAssets = userAssets.map((a) => (a.assetId === mintAsset.assetId ? { ...a, nftMintAddress: res.mintAddress } : a));
      setUserAssets(updatedAssets);
      const updatedUser = { ...user, userAssets: updatedAssets };
      setUser(updatedUser);
      localStorage.setItem('currentUser', JSON.stringify(updatedUser));
      setMintAsset(null); setMintPassword('');
      setMintResult(res);
      fetchSolanaBalance();
      loadUserAssets(user.genesisID);
    } catch (e) {
      setMintError(e.signature ? `${e.message} (tx: ${e.signature.slice(0, 10)}…)` : e.message);
    } finally {
      setMintBusy(false); setMintingNft(null); setMintStep('');
    }
  };
  // ===== END MINT NFT =====

  const handleLogout = () => {
    if (user?.solanaSecretKey && !vaultProtected &&
        !window.confirm('Your wallet key is not protected on this device and will be removed on logout. Make sure you have your backup file. Log out anyway?')) return;
    localStorage.removeItem('currentUser');
    onNavigate('home');
  };

  const handleImageError = (e) => {
    console.error('Image load error:', e.target.src);
    setAvatarUrl('');
  };

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const getFieldsCompletion = (fields) => {
    const total = fields.length;
    const completed = fields.filter(field => user[field] && user[field].toString().trim() !== '').length;
    return { completed, total };
  };

  // Helper function to get role display name
  const getRoleDisplayName = (role) => {
    const roleMap = {
      'Model': 'Model',
      'Designer': 'Fashion Designer',
      'Photographer': 'Photographer',
      'Stylist': 'Stylist',
      'MUA': 'Makeup Artist',
      'Agency': 'Agency',
      'Brand': 'Brand',
      'Creative': 'Creative Professional',
      'Entrepreneur': 'Entrepreneur',
      'Other': 'Other'
    };
    return roleMap[role] || role;
  };

  if (!user) {
    return <div className="loading">Loading profile...</div>;
  }

  // Determine if user has userRole (new system) or not (old system)
  const hasRole = user.userRole && user.userRole !== '';
  const isModel = !hasRole || user.userRole === 'Model';
  const isCreative = ['Designer', 'Photographer', 'Stylist', 'MUA', 'Creative', 'Other'].includes(user.userRole);
  const isCompany = ['Agency', 'Brand'].includes(user.userRole);
  const isEntrepreneur = user.userRole === 'Entrepreneur';
  const isVIP = user.registrationSource === 'vip';

  return (
    <div className="profile-container">
    {/* Close asset menu on outside click */}
{showAssetMenu && (
  <div
    onClick={() => setShowAssetMenu(null)}
    style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 99 }}
  />
)}

      <div className="profile-card">
        <div className="profile-header">
          <h2>Genesis Profile</h2>
          <div className="genesis-id-display">
            <span className="id-label">Genesis ID</span>
            <span className="id-number">{user.genesisID}</span>
          </div>
        </div>

        <div className="avatar-section">
          <div className="avatar-preview">
            {avatarUrl ? (
              <img src={avatarUrl} alt="Profile" onError={handleImageError} />
            ) : (
              <div className="avatar-placeholder">No Image</div>
            )}
          </div>
        </div>

        <div className="tab-navigation">
          <button className={`tab-button ${activeTab === 'profile' ? 'active' : ''}`} onClick={() => setActiveTab('profile')}>
            Profile
          </button>
          <button className={`tab-button ${activeTab === 'media' ? 'active' : ''}`} onClick={() => setActiveTab('media')}>
            TheoNFT
          </button>
          <button className={`tab-button ${activeTab === 'wallet' ? 'active' : ''}`} onClick={() => setActiveTab('wallet')}>
            TheoWallet
          </button>
          <button className={`tab-button ${activeTab === 'documents' ? 'active' : ''}`} onClick={() => setActiveTab('documents')}>
            Certificates
          </button>
                    <button className={`tab-button ${activeTab === 'circle' ? 'active' : ''}`} onClick={() => setActiveTab('circle')}>
            Social Circle & Level-Up Pyramid
          </button>
        </div>

        <div className="tab-content">
          {/* ========== PROFILE TAB (ОНОВЛЕНО) ========== */}
          {activeTab === 'profile' && (
            <InfoFieldContext.Provider value={{
              genesisID: user.genesisID,
              onSaved: (saved) => setUser((prev) => {
                const updatedUser = { ...prev, ...saved };
                localStorage.setItem('currentUser', JSON.stringify(updatedUser));
                return updatedUser;
              })
            }}>
              {/* Personal Information */}
              <div className="expandable-section">
                <div className="section-header" onClick={() => toggleSection('personal')}>
                  <span className={`expand-icon ${expandedSections.personal ? 'expanded' : ''}`}>▶</span>
                  <h3>Personal Information</h3>
                  <span className="completion-indicator">
                    {(() => {
                      let fields = ['firstName', 'lastName'];
                      if (hasRole) {
                        fields.push('userRole');
                        if (isModel) fields.push('dateOfBirth', 'age', 'nationality', 'languages', 'address');
                        if (isCreative || isCompany || isEntrepreneur) fields.push('city', 'country', 'nationality', 'languages');
                      } else {
                        fields.push('dateOfBirth', 'age', 'nationality', 'languages', 'address');
                      }
                      const completion = getFieldsCompletion(fields);
                      return `${completion.completed}/${completion.total}`;
                    })()}
                  </span>
                </div>
                {expandedSections.personal && (
                  <div className="section-content">
                    <div className="info-grid">
                      <InfoField label="First Name" value={user.firstName} required fieldName="firstName" />
                      <InfoField label="Last Name" value={user.lastName} required fieldName="lastName" />
                      
                      {hasRole && (
                        <InfoField label="Role" value={getRoleDisplayName(user.userRole)} />
                      )}
                      
                      {(isModel || !hasRole) && (
                        <>
                          <InfoField label="Date of Birth" value={user.dateOfBirth} fieldName="dateOfBirth" />
                          <InfoField label="Age (from date of birth)" value={user.age} />
                          <InfoField label="Nationality" value={user.nationality} fieldName="nationality" />
                          <InfoField label="Languages" value={user.languages} fieldName="languages" />
                          <InfoField label="Address" value={user.address} fieldName="address" />
                        </>
                      )}
                      
                      {(isCreative || isCompany || isEntrepreneur) && (
                        <>
                          <InfoField label="Nationality" value={user.nationality} fieldName="nationality" />
                          <InfoField label="Languages" value={user.languages} fieldName="languages" />
                          <InfoField label="City" value={user.city} fieldName="city" />
                          <InfoField label="Country" value={user.country} fieldName="country" />
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* Company Information (Agency/Brand only) */}
              {isCompany && (
                <div className="expandable-section">
                  <div className="section-header" onClick={() => toggleSection('company')}>
                    <span className={`expand-icon ${expandedSections.company ? 'expanded' : ''}`}>▶</span>
                    <h3>Company Information</h3>
                    <span className="completion-indicator">
                      {(() => {
                        const completion = getFieldsCompletion(['companyName', 'businessType', 'contactPerson', 'companyDescription', 'servicesOffered', 'companyWebsite']);
                        return `${completion.completed}/${completion.total}`;
                      })()}
                    </span>
                  </div>
                  {expandedSections.company && (
                    <div className="section-content">
                      <div className="info-grid">
                        <InfoField label="Company Name" value={user.companyName} fieldName="companyName" />
                        <InfoField label="Type of Business" value={user.businessType} fieldName="businessType" />
                        <InfoField label="Contact Person" value={user.contactPerson} fieldName="contactPerson" />
                        <InfoField label="Company Description" value={user.companyDescription} fieldName="companyDescription" />
                        <InfoField label="Services Offered" value={user.servicesOffered} fieldName="servicesOffered" />
                        <InfoField label="Notable Clients" value={user.notableClients} fieldName="notableClients" />
                        <InfoField label="Company Website" value={user.companyWebsite} fieldName="companyWebsite" />
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Business Information (Entrepreneur only) */}
              {isEntrepreneur && (
                <div className="expandable-section">
                  <div className="section-header" onClick={() => toggleSection('business')}>
                    <span className={`expand-icon ${expandedSections.business ? 'expanded' : ''}`}>▶</span>
                    <h3>Business Information</h3>
                    <span className="completion-indicator">
                      {(() => {
                        const completion = getFieldsCompletion(['companyName', 'businessType', 'businessDescription', 'visionMission', 'companyWebsite']);
                        return `${completion.completed}/${completion.total}`;
                      })()}
                    </span>
                  </div>
                  {expandedSections.business && (
                    <div className="section-content">
                      <div className="info-grid">
                        <InfoField label="Company Name" value={user.companyName} fieldName="companyName" />
                        <InfoField label="Type of Business" value={user.businessType} fieldName="businessType" />
                        <InfoField label="Business Description" value={user.businessDescription} fieldName="businessDescription" />
                        <InfoField label="Vision / Mission" value={user.visionMission} fieldName="visionMission" />
                        <InfoField label="Company Website" value={user.companyWebsite} fieldName="companyWebsite" />
                        <InfoField label="LinkedIn" value={user.linkedin} fieldName="linkedin" />
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Physical Characteristics (Model only or no role) */}
              {(isModel || !hasRole) && (
                <div className="expandable-section">
                  <div className="section-header" onClick={() => toggleSection('physical')}>
                    <span className={`expand-icon ${expandedSections.physical ? 'expanded' : ''}`}>▶</span>
                    <h3>Physical Characteristics</h3>
                    <span className="completion-indicator">
                      {(() => {
                        const completion = getFieldsCompletion(['hairColor', 'eyeColor', 'height', 'bodyType']);
                        return `${completion.completed}/${completion.total}`;
                      })()}
                    </span>
                  </div>
                  {expandedSections.physical && (
                    <div className="section-content">
                      <div className="info-grid">
                        <InfoField label="Hair Color" value={user.hairColor} fieldName="hairColor" />
                        <InfoField label="Eye Color" value={user.eyeColor} fieldName="eyeColor" />
                        <InfoField label="Height" value={user.height} fieldName="height" />
                        <InfoField label="Body Type" value={user.bodyType} fieldName="bodyType" />
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Professional Information */}
              <div className="expandable-section">
                <div className="section-header" onClick={() => toggleSection('professional')}>
                  <span className={`expand-icon ${expandedSections.professional ? 'expanded' : ''}`}>▶</span>
                  <h3>Professional Information</h3>
                  <span className="completion-indicator">
                    {(() => {
                      let fields = [];
                      if (isModel || !hasRole) {
                        fields = ['professionalBio', 'fashionExperience', 'skills', 'education', 'workplace', 'location', 'portfolioWebsite'];
                      } else if (isCreative) {
                        fields = ['professionalBio', 'creativeVision', 'yearsOfExperience', 'notableProjects', 'skills', 'education', 'workplace', 'location', 'portfolioWebsite', 'linkedin'];
                      } else if (isCompany) {
                        fields = ['yearsOfExperience'];
                      } else if (isEntrepreneur) {
                        fields = ['yearsOfExperience'];
                      }
                      const completion = getFieldsCompletion(fields);
                      return `${completion.completed}/${completion.total}`;
                    })()}
                  </span>
                </div>
                {expandedSections.professional && (
                  <div className="section-content">
                    <div className="info-grid">
                      {(isModel || !hasRole) && (
                        <>
                          <InfoField label="Professional Bio" value={user.professionalBio || user.personalQuote} fieldName="professionalBio" />
                          <InfoField label="Fashion Experience" value={user.fashionExperience} fieldName="fashionExperience" />
                          <InfoField label="Skills" value={user.skills} fieldName="skills" />
                          <InfoField label="Education" value={user.education} fieldName="education" />
                          <InfoField label="Workplace" value={user.workplace} fieldName="workplace" />
                          <InfoField label="Location" value={user.location} fieldName="location" />
                          <InfoField label="Portfolio Website" value={user.portfolioWebsite} fieldName="portfolioWebsite" />
                        </>
                      )}
                      
                      {isCreative && (
                        <>
                          <InfoField label="Professional Bio" value={user.professionalBio} fieldName="professionalBio" />
                          <InfoField label="Creative Vision" value={user.creativeVision} fieldName="creativeVision" />
                          <InfoField label="Years of Experience" value={user.yearsOfExperience} fieldName="yearsOfExperience" />
                          <InfoField label="Notable Projects" value={user.notableProjects} fieldName="notableProjects" />
                          <InfoField label="Skills" value={user.skills} fieldName="skills" />
                          <InfoField label="Education" value={user.education} fieldName="education" />
                          <InfoField label="Current Company" value={user.workplace} fieldName="workplace" />
                          <InfoField label="Work Location" value={user.location} fieldName="location" />
                          <InfoField label="Portfolio Website" value={user.portfolioWebsite} fieldName="portfolioWebsite" />
                          <InfoField label="LinkedIn" value={user.linkedin} fieldName="linkedin" />
                        </>
                      )}
                      
                      {isCompany && (
                        <InfoField label="Years in Business" value={user.yearsOfExperience} fieldName="yearsOfExperience" />
                      )}
                      
                      {isEntrepreneur && (
                        <InfoField label="Years of Experience" value={user.yearsOfExperience} fieldName="yearsOfExperience" />
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* Contact Information */}
              <div className="expandable-section">
                <div className="section-header" onClick={() => toggleSection('contact')}>
                  <span className={`expand-icon ${expandedSections.contact ? 'expanded' : ''}`}>▶</span>
                  <h3>Contact Information</h3>
                  <span className="completion-indicator">
                    {(() => {
                      const completion = getFieldsCompletion(['email', 'phone', 'telegram', 'instagram']);
                      return `${completion.completed}/${completion.total}`;
                    })()}
                  </span>
                </div>
                {expandedSections.contact && (
                  <div className="section-content">
                    <div className="info-grid">
                      <InfoField label="Email (change in Security below)" value={user.email} />
                      <InfoField label="Phone" value={user.phone} fieldName="phone" />
                      <InfoField label="Telegram" value={user.telegram} fieldName="telegram" />
                      <InfoField label="Instagram" value={user?.instagram} fieldName="instagram" />
                      {isVIP && <InfoField label="LinkedIn" value={user?.linkedin} fieldName="linkedin" />}
                      {(isModel || !hasRole) && (
                        <InfoField label="Address" value={user.address} fieldName="address" />
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* Registration Details */}
              <div className="expandable-section">
                <div className="section-header" onClick={() => toggleSection('registration')}>
                  <span className={`expand-icon ${expandedSections.registration ? 'expanded' : ''}`}>▶</span>
                  <h3>Registration Details</h3>
                </div>
                {expandedSections.registration && (
                  <div className="section-content">
                    <div className="info-grid">
                      <InfoField label="Genesis ID" value={user.genesisID} />
                      <InfoField label="Registration Date" value={new Date(user.registrationDate).toLocaleDateString()} />
                      {user.registrationSource && (
                        <InfoField label="Registration Type" value={user.registrationSource === 'vip' ? 'VIP Registration' : 'Standard Registration'} />
                      )}
                    </div>
                  </div>
                )}
              </div>
                          {/* Security: зміна пароля */}
              <ChangePasswordCard
                genesisID={user.genesisID}
                email={user.email}
                onEmailChanged={(newEmail) => {
                  const updatedUser = { ...user, email: newEmail };
                  setUser(updatedUser);
                  localStorage.setItem('currentUser', JSON.stringify(updatedUser));
                }}
              />
            </InfoFieldContext.Provider>
          )}

          {/* ========== MEDIA TAB (БЕЗ ЗМІН) ========== */}
          {activeTab === 'media' && (
            <div className="media-section">
              <div className="media-options">
                <div className="media-card">
                  <h4>📸 Upload Profile Photo</h4>
                  <p>Upload your profile photo</p>
                  <AvatarUploader 
                    genesisID={user.genesisID}
                    onUploaded={(url) => {
                      setAvatarUrl(url);
                      const updatedUser = { ...user, photoUrl: url };
                      setUser(updatedUser);
                      localStorage.setItem('currentUser', JSON.stringify(updatedUser));
                    }}
                  />
                </div>

                <div className="media-card">
                  <h4>🔍 Scan Genesis Assets</h4>
                  <p>Scan existing QR codes or text codes from physical objects</p>
                  <div className="scanner-buttons">
                    <button className="btn-qr" onClick={startQRScanning} disabled={isScanning || uploading}>
                      {isScanning ? 'Scanning...' : 'Scan QR Code'}
                    </button>
                    <button className="btn-qr" onClick={handleOCRScan} disabled={uploading}>
                      {uploading ? 'Processing...' : 'Scan Text Code'}
                    </button>
                  </div>
                </div>

                <label style={{ display: 'flex', gap: '10px', alignItems: 'center', fontSize: '14px', color: '#444', cursor: 'pointer', textAlign: 'left' }}>
                  <input type="checkbox" checked={attachLocation} onChange={(e) => setAttachLocation(e.target.checked)} />
                  <span>📍 Add photo location (GPS) to new assets and certificates</span>
                </label>

                <div className="media-card">
                  <h4>📤 Upload Asset Photo</h4>
                  <p>Upload a photo of your asset from gallery</p>
                  <input 
                    type="file" 
                    accept="image/*" 
                    onChange={handleAssetUpload}
                    ref={assetInputRef}
                    disabled={uploading}
                  />
                  {assetFile && (
                    <button 
                      className="btn-asset" 
                      onClick={uploadSelectedAsset}
                      disabled={uploading}
                    >
                      {uploading ? 'Uploading...' : 'Upload Selected File'}
                    </button>
                  )}
                </div>

                <div className="media-card">
                  <h4>📷 Create New Asset</h4>
                  <p>Take a photo to create a new blockchain asset</p>
                  <button className="btn-asset" onClick={() => cameraInputRef.current?.click()} disabled={uploading}>
                    {uploading ? 'Creating Asset...' : 'Open Camera'}
                  </button>
                  <input
                    ref={cameraInputRef}
                    type="file"
                    accept="image/*"
                    capture="environment"
                    onChange={handleNativeCapture}
                    style={{ display: 'none' }}
                  />
                </div>
              </div>

              {showCamera && (
                <div className="camera-modal">
                  <div className="camera-content">
                    {!capturedImage ? (
                      <>
                        <Webcam
                          ref={webcamRef}
                          screenshotFormat="image/jpeg"
                          screenshotQuality={0.95}
                          forceScreenshotSourceSize
                          videoConstraints={{
                            facingMode: "environment",
                            width: { ideal: 2560 },
                            height: { ideal: 1440 }
                          }}
                        />
                        <div className="camera-controls">
                          <button className="btn-capture" onClick={captureNewAssetPhoto}>
                            📸 Capture
                          </button>
                          <button className="btn-cancel" onClick={cancelAssetCreation}>
                            Cancel
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <img src={capturedImage} alt="Captured" />
                        <div className="camera-controls">
                          <button className="btn-asset" onClick={uploadCapturedAsset} disabled={uploading}>
                            {uploading ? 'Creating Asset...' : 'Create Asset'}
                          </button>
                          <button className="btn-retake" onClick={() => setCapturedImage(null)}>
                            Retake
                          </button>
                          <button className="btn-cancel" onClick={cancelAssetCreation}>
                            Cancel
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}

              {isScanning && (
                <div className="qr-scanner-modal">
                  <div className="qr-scanner-content">
                    <BarcodeScanner
                      onUpdate={(err, result) => {
                        if (result) {
                          handleQRScan(result.text);
                        }
                      }}
                    />
                    <button className="btn-cancel" onClick={stopQRScanning}>
                      Cancel Scan
                    </button>
                  </div>
                </div>
              )}

              <div className="assets-section">
                <h3>Your Assets ({userAssets.length})</h3>
                {loadingAssets ? (
                  <p>Loading assets...</p>
                ) : userAssets.length === 0 ? (
                  <p className="no-assets">No assets yet. Create your first blockchain asset!</p>
                ) : (
                  <div className="assets-grid">
                    {userAssets.map((asset) => (
                      <div key={asset.assetId} className="asset-card">
<img
  src={asset.imageUrl || 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200"><rect width="200" height="200" fill="%23f5f5f5"/><text x="50%" y="50%" font-size="14" fill="%23999" text-anchor="middle" dy=".3em">No Image</text></svg>'}
  alt={asset.title || 'Asset'}
  className="asset-image"
  style={{ cursor: asset.imageUrl ? 'pointer' : 'default' }}
  onClick={() => asset.imageUrl && window.open(asset.imageUrl, '_blank')}
  onError={e => {
    e.target.onerror = null;
    e.target.src = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200"><rect width="200" height="200" fill="%23f0f0f0"/><text x="50%" y="50%" font-size="14" fill="%23999" text-anchor="middle" dy=".3em">No Image</text></svg>';
  }}
/>
                         <div className="asset-info">
                          <h4>{asset.title || 'Genesis Asset'}</h4>
                          <p className="asset-date">{new Date(asset.timestamp).toLocaleDateString()}</p>
<div className="asset-actions">
  {/* NEW: hamburger menu ☰ */}
  <div style={{ position: 'relative', display: 'flex', justifyContent: 'flex-start' }}>
    <button
      onClick={() => setShowAssetMenu(showAssetMenu === asset.assetId ? null : asset.assetId)}
      style={{
        background: '#f0f0f0',
        border: '1px solid #ddd',
        borderRadius: '6px',
        padding: '6px 14px',
        cursor: 'pointer',
        fontSize: '18px'
      }}>
      ☰
    </button>

{showAssetMenu === asset.assetId && (
  <div style={{
    position: 'absolute',
    left: '-240px',
    top: '-170px',
    backgroundColor: 'white',
    border: '1px solid #ddd',
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    zIndex: 100,
    minWidth: '220px',
    overflow: 'hidden'
  }}>
    {/* 1. Genesis Memo (колишній Get Certificate) */}
    <button
      onClick={() => {
        generateAssetCertificate(asset.assetId); // сервер сам віддасть готовий PDF, якщо нічого не змінилося
        setShowAssetMenu(null);
      }}
      disabled={generatingCertificate === asset.assetId}
      style={{ display: 'block', width: '100%', padding: '12px 16px', border: 'none', background: 'none', textAlign: 'left', cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}>
      {generatingCertificate === asset.assetId ? '⏳ Generating...' : '📄 Certificate'}
    </button>

    {/* 3. Mint NFT або View on Solana (замість повторного запиту ключа) */}
    {asset.nftMintAddress ? (
      <button
        onClick={() => {
          window.open(`https://explorer.solana.com/address/${asset.nftMintAddress}`, '_blank');
          setShowAssetMenu(null);
        }}
        style={{ display: 'block', width: '100%', padding: '12px 16px', border: 'none', background: '#f0fdf4', color: '#16a34a', textAlign: 'left', cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}>
        ✅ View on Solana
      </button>
    ) : (
      <button
        onClick={() => {
          mintNFT(asset);
          setShowAssetMenu(null);
        }}
        disabled={mintingNft === asset.assetId}
        style={{ display: 'block', width: '100%', padding: '12px 16px', border: 'none', background: 'none', textAlign: 'left', cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}>
        {mintingNft === asset.assetId ? '⏳ Minting...' : '🪙 Mint NFT'}
      </button>
    )}

    {/* 4. Transfer Asset */}
    <button
      onClick={() => {
        setSelectedAsset(asset);
        setShowTransferModal(true);
        setShowAssetMenu(null);
      }}
      style={{ display: 'block', width: '100%', padding: '12px 16px', border: 'none', background: 'none', textAlign: 'left', cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}>
      ➡️ Transfer Asset
    </button>

  </div>
)}
  </div>
</div>


                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}

{/* ========== WALLET TAB (БЕЗ ЗМІН СТРУКТУРИ) ========== */}
          {activeTab === 'wallet' && (
            <div className="wallet-section" style={{ display: 'flex', flexDirection: 'column' }}>
              <h3>Genesis Wallet</h3>

              {/* ── EVM (ETH/BSC) гаманець ── */}
              {walletCreated && (
              <details style={{ order: 2, marginTop: '16px', fontSize: '14px' }}>
                <summary style={{ cursor: 'pointer', color: '#888', padding: '8px 4px' }}>Other networks (ETH / BSC)</summary>
                {!walletCreated ? (
                  <div className="wallet-create">
                    <p>Create a secure crypto wallet to store your Genesis assets as NFTs</p>
                    <button className="btn-create-wallet" onClick={generateWallet}>Create EVM Wallet</button>
                  </div>
                ) : (
                  <div className="wallet-info">
                    {/* Поле з адресою та кнопкою копіювання для EVM */}
                    <div className="wallet-address-container" style={{ marginBottom: '15px' }}>
                      <label style={{ fontSize: '12px', color: '#888', display: 'block', marginBottom: '5px' }}>Wallet Address</label>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <input 
                          type="text" 
                          value={walletAddress} 
                          readOnly 
                          style={{ flex: 1, padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '13px', background: '#fff', color: '#333' }} 
                        />
                        <button 
                          onClick={() => { navigator.clipboard.writeText(walletAddress); alert('EVM Address copied!'); }}
                          style={{ padding: '0 12px', borderRadius: '8px', border: '1px solid #ddd', background: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                        >
                          📋
                        </button>
                      </div>
                    </div>
                    <div className="wallet-balance">
                      <label>Balance</label>
                      <p>{evmBalances.ETH || '0'} ETH · {evmBalances.BSC || '0'} BNB</p>
                    </div>
                    {privateKey && (
                      <div className="wallet-backup">
                        <p className="warning">Save your private key securely!</p>
                        <button className="btn-download-backup" onClick={downloadBackup}>Download Backup</button>
                      </div>
                    )}
                  </div>
                )}
              </details>
              )}

              {/* ── Solana Wallet ── */}
              <div style={{ background: '#f9f9f9', padding: '15px', borderRadius: '15px' }}>

                
                {!solanaWalletCreated ? (
                  <div className="wallet-create" style={{ textAlign: 'center' }}>
                    <p style={{ fontSize: '14px', color: '#666', marginBottom: '15px' }}>
                      Your TheoWallet key is created and encrypted on this device. Genesis never receives it.
                    </p>
                    <button 
                      className="btn-create-wallet" 
                      onClick={() => setShowCreateWallet(true)}
                      disabled={uploading}
                      style={{ backgroundColor: '#9945FF', color: 'white', width: '100%' }}
                    >
                      Create TheoWallet
                    </button>
                  </div>
                ) : (
                  <div className="wallet-info">
                    {/* ===== GENESIS ASSETS ===== */}
                    {(() => {
                      const assets = walletAssetList();
                      const priced = Object.keys(tokenPrices).length > 0;
                      const total = assets.reduce((s, a) => s + (parseFloat(a.balance) || 0) * (tokenPrices[a.symbol] || 0), 0);
                      return (
                        <>
                          <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: '12px', padding: '14px', marginBottom: '10px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                              <div>
                                <div style={{ fontSize: '12px', color: '#888' }}>Total balance</div>
                                <div style={{ fontSize: '26px', fontWeight: 700 }}>{priced ? usd(total) : '—'}</div>
                              </div>
                              <button onClick={refreshWallet} title="Refresh"
                                style={{ width: '36px', height: '36px', borderRadius: '50%', border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: '16px' }}>
                                ↻
                              </button>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px', marginTop: '10px' }}>
                              <button onClick={() => { navigator.clipboard.writeText(solanaAddress); alert('Address copied!'); }}
                                style={{ fontFamily: 'monospace', fontSize: '13px', background: '#f5f5f5', border: '1px solid #eee', borderRadius: '8px', padding: '8px 10px', cursor: 'pointer' }}>
                                {solanaAddress.slice(0, 4)}…{solanaAddress.slice(-4)} 📋
                              </button>
                              <button onClick={() => openReceive('SOL, THEO, USDC, USDT')}
                                style={{ padding: '8px 18px', borderRadius: '8px', border: 'none', background: '#1e293b', color: '#fff', cursor: 'pointer', fontWeight: 600 }}>
                                Receive
                              </button>
                            </div>
                          </div>

                          <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: '12px', overflow: 'hidden' }}>
                            {assets.map((a, i) => {
                              const bal = parseFloat(a.balance);
                              const price = tokenPrices[a.symbol];
                              return (
                                <div key={a.symbol} onClick={() => setAssetMenu(a.symbol)}
                                  style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '12px', cursor: 'pointer', borderTop: i ? '1px solid #f0f0f0' : 'none' }}>
                                  {assetLogo(a, '34px')}
                                  <div style={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
                                    <div style={{ fontWeight: 700 }}>{a.symbol}</div>
                                    <div style={{ fontSize: '12px', color: '#888' }}>{a.name}</div>
                                  </div>
                                  <div style={{ textAlign: 'right' }}>
                                    <div style={{ fontWeight: 700 }}>{a.balance == null ? '—' : bal.toLocaleString('en-US', { maximumFractionDigits: 6 })}</div>
                                    <div style={{ fontSize: '12px', color: '#888' }}>{price && !isNaN(bal) ? usd(bal * price) : ''}</div>
                                  </div>
                                  <span style={{ color: '#bbb', fontSize: '20px', marginLeft: '2px' }}>›</span>
                                </div>
                              );
                            })}
                          </div>
                        </>
                      );
                    })()}
                    {/* ===== END GENESIS ASSETS ===== */}
                    
                    {/* ===== WALLET SECURITY ===== */}
                                        {vaultProtected ? (
                      <>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '13px', padding: '12px 4px 0' }}>
                          <span style={{ color: '#16a34a', fontWeight: 600 }}>🟢 Protected with password</span>
                          <button onClick={() => setSecurityModal('export')}
                            style={{ background: 'none', border: 'none', color: '#4f46e5', cursor: 'pointer', fontSize: '13px', padding: 0 }}>
                            Export backup
                          </button>
                        </div>
                        {passkeySupported && (
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '13px', padding: '8px 4px 0' }}>
                            <span style={{ color: passkeyOn ? '#16a34a' : '#888', fontWeight: 600 }}>
                              {passkeyOn ? '🟢 Face ID / fingerprint: On' : '⚪ Face ID / fingerprint: Off'}
                            </span>
                            <button onClick={passkeyOn ? handleDisableFaceId : () => setFaceIdStep('password')}
                              style={{ background: 'none', border: 'none', color: passkeyOn ? '#888' : '#4f46e5', cursor: 'pointer', fontSize: '13px', padding: 0 }}>
                              {passkeyOn ? 'Turn off' : 'Enable'}
                            </button>
                          </div>
                        )}
                      </>
                    ) : user?.solanaSecretKey ? (
                      <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '12px', padding: '12px', marginTop: '10px' }}>
                        <p style={{ color: '#dc2626', fontWeight: 600, margin: '0 0 6px 0' }}>🔴 Wallet key is not protected</p>
                        <p style={{ fontSize: '12px', color: '#666', margin: '0 0 10px 0' }}>Set a password to encrypt your key on this device. Required for Send and Swap.</p>
                        <button onClick={() => setSecurityModal('protect')}
                          style={{ width: '100%', padding: '10px', borderRadius: '8px', border: 'none', background: '#dc2626', color: '#fff', cursor: 'pointer', fontWeight: 600 }}>
                          Protect wallet
                        </button>
                      </div>
                    ) : (
                      <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '12px', marginTop: '10px' }}>
                        <p style={{ color: '#475569', fontWeight: 600, margin: '0 0 6px 0' }}>⚪ Wallet key not found on this device</p>
                        <p style={{ fontSize: '12px', color: '#666', margin: '0 0 10px 0' }}>Import your backup file to Send and Swap from this device.</p>
                        <button onClick={() => setSecurityModal('import')}
                          style={{ width: '100%', padding: '10px', borderRadius: '8px', border: 'none', background: '#1e293b', color: '#fff', cursor: 'pointer', fontWeight: 600 }}>
                          Import backup
                        </button>
                      </div>
                    )}
                    {/* ===== END WALLET SECURITY ===== */}

                  </div>
                )}
              </div>
            </div>
          )}
          {/* ========== CIRCLE TAB ========== */}
          {activeTab === 'circle' && (
            <CircleTab
              user={user}
              assets={userAssets}
              onSendToken={(symbol, genesisID) => { openSend(symbol); setSendTo(genesisID); }}
              onTransferAsset={(asset, genesisID) => { setSelectedAsset(asset); setTransferGenesisID(genesisID); setShowTransferModal(true); }}
            />
          )}
          {/* ========== DOCUMENTS TAB (БЕЗ ЗМІН) ========== */}
          {activeTab === 'documents' && (
            <div className="documents-section">
              <div className="media-options">
                <CertificateGenerator 
                  user={user} 
                  onGoToWallet={() => setActiveTab('wallet')}
                  onUserUpdate={(updatedUser) => {
                    setUser(updatedUser);
                  }}
                />

                <div className="media-card">
                  <h4>📤 Share Genesis Profile</h4>
                  <p>Share your profile or connect with other Genesis users</p>
                  <div className="share-buttons" style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                    <button 
                      className="btn-qr" 
                      onClick={generateMyQRCode} 
                      disabled={uploading}
                      style={{width: '100%'}}
                    >
                      Generate My QR Code
                    </button>
                    <button 
                      className="btn-asset" 
                      onClick={startNFCShare} 
                      disabled={uploading || !nfcSupported}
                      style={{width: '100%'}}
                    >
                      Share via NFC
                    </button>
                    <button 
                      className="btn-asset" 
                      onClick={startNFCScanning} 
                      disabled={nfcScanning || !nfcSupported}
                      style={{width: '100%'}}
                    >
                      {nfcScanning ? 'NFC Scanning...' : 'Scan NFC'}
                    </button>
                    <button 
                      className="btn-qr" 
                      onClick={showFindUserDialog}
                      style={{width: '100%'}}
                    >
                      Find User by Genesis ID
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

{/* ── MINT RESULT MODAL ── */}
{mintResult && (
  <div
    className="modal-overlay"
    style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 1001,
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}
    onClick={() => setMintResult(null)}
  >
    <div
      style={{
        backgroundColor: 'white', padding: '24px', borderRadius: '20px',
        maxWidth: '500px', width: '90%', maxHeight: '85vh', overflowY: 'auto'
      }}
      onClick={e => e.stopPropagation()}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h3 style={{ margin: 0 }}>
          {mintResult.alreadyMinted ? '✅ NFT Already Minted' : '🎉 NFT Successfully Minted!'}
        </h3>
        <button
          onClick={() => setMintResult(null)}
          style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}
        >
          ×
        </button>
      </div>

      <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '16px', marginBottom: '20px' }}>
        <div style={{ marginBottom: '12px' }}>
          <span style={{ color: '#64748b', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase' }}>
            NFT Address
          </span>
          <div style={{
            fontFamily: 'monospace', fontSize: '13px', wordBreak: 'break-all',
            marginTop: '4px', color: '#1e293b', background: '#f1f5f9', padding: '8px',
            borderRadius: '6px'
          }}>
            {mintResult.mintAddress}
          </div>
        </div>
        {mintResult.txHash && (
          <div style={{ marginBottom: '12px' }}>
            <span style={{ color: '#64748b', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase' }}>
              Transaction
            </span>
            <div style={{
              fontFamily: 'monospace', fontSize: '13px', wordBreak: 'break-all',
              marginTop: '4px', color: '#1e293b', background: '#f1f5f9', padding: '8px',
              borderRadius: '6px'
            }}>
              {mintResult.txHash}
            </div>
          </div>
        )}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <button
          onClick={() => window.open(`https://explorer.solana.com/address/${mintResult.mintAddress}`, '_blank')}
          style={{
            padding: '16px', background: '#9945FF', color: 'white',
            border: 'none', borderRadius: '12px', fontSize: '16px', fontWeight: 600,
            cursor: 'pointer', transition: 'background 0.2s'
          }}
          onMouseOver={e => e.target.style.background = '#7c3aed'}
          onMouseOut={e => e.target.style.background = '#9945FF'}
        >
          🔗 View NFT on Solana Explorer
        </button>
        {mintResult.txHash && (
          <button
            onClick={() => window.open(`https://explorer.solana.com/tx/${mintResult.txHash}`, '_blank')}
            style={{
              padding: '16px', background: '#059669', color: 'white',
              border: 'none', borderRadius: '12px', fontSize: '16px', fontWeight: 600,
              cursor: 'pointer'
            }}
          >
            📄 View Transaction
          </button>
        )}
        {mintResult.metadataUri && (
          <button
            onClick={() => window.open(mintResult.metadataUri, '_blank')}
            style={{
              padding: '16px', background: '#f59e0b', color: 'white',
              border: 'none', borderRadius: '12px', fontSize: '16px', fontWeight: 600,
              cursor: 'pointer'
            }}
          >
            🌐 View Metadata on IPFS
          </button>
        )}
        <button
          onClick={() => setMintResult(null)}
          style={{
            padding: '16px', background: '#f1f5f9', color: '#334155',
            border: '1px solid #e2e8f0', borderRadius: '12px', fontSize: '16px',
            cursor: 'pointer'
          }}
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}

        <div className="profile-actions">
          <button className="btn-logout" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>

      {/* Modals */}
      {myQRCode && (
        <div 
          className="modal-overlay" 
          style={{
            position: 'fixed', 
            top: 0, 
            left: 0, 
            right: 0, 
            bottom: 0, 
            backgroundColor: 'rgba(0,0,0,0.5)', 
            zIndex: 1000, 
            display: 'flex', 
            alignItems: 'flex-end', 
            justifyContent: 'center'
          }}
          onClick={() => setMyQRCode(null)}
        >
          <div 
            className="qr-modal" 
            style={{
              backgroundColor: 'white', 
              padding: '20px', 
              borderRadius: '20px 20px 0 0', 
              maxWidth: '400px', 
              width: '100%', 
              textAlign: 'center'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3>My Genesis QR Code</h3>
            <img src={myQRCode} alt="My QR Code" style={{maxWidth: '200px', margin: '15px 0'}} />
            <p>Share this QR code to let others access your certificate</p>
            <div style={{display: 'flex', gap: '10px', marginTop: '15px'}}>
              <button className="btn-asset" onClick={downloadQRCode} style={{flex: 1}}>
                Download QR
              </button>
              <button className="cancel-button" onClick={() => setMyQRCode(null)} style={{flex: 1}}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {showAssetInfo && assetOwner && (
        <div 
          className="modal-overlay" 
          style={{
            position: 'fixed', 
            top: 0, 
            left: 0, 
            right: 0, 
            bottom: 0, 
            backgroundColor: 'rgba(0,0,0,0.5)', 
            zIndex: 1000, 
            display: 'flex', 
            alignItems: 'flex-end', 
            justifyContent: 'center'
          }}
          onClick={() => setShowAssetInfo(false)}
        >
          <div 
            className="asset-info-modal" 
            style={{
              backgroundColor: 'white', 
              padding: '20px', 
              borderRadius: '20px 20px 0 0', 
              maxWidth: '400px', 
              width: '100%'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Asset Information</h3>
            <p><strong>Asset Code:</strong> {assetOwner.assetCode}</p>
            <p><strong>Owner:</strong> {assetOwner.ownerName}</p>
            <p><strong>Genesis ID:</strong> {assetOwner.ownerGenesisID}</p>
            <p><strong>Registered:</strong> {new Date(assetOwner.timestamp).toLocaleString()}</p>
            <button className="cancel-button" onClick={() => setShowAssetInfo(false)}>
              Close
            </button>
          </div>
        </div>
      )}

      {showFindUser && (
        <div 
          className="modal-overlay" 
          style={{
            position: 'fixed', 
            top: 0, 
            left: 0, 
            right: 0, 
            bottom: 0, 
            backgroundColor: 'rgba(0,0,0,0.5)', 
            zIndex: 1000, 
            display: 'flex', 
            alignItems: 'flex-end', 
            justifyContent: 'center'
          }}
          onClick={() => setShowFindUser(false)}
        >
          <div 
            className="find-user-modal" 
            style={{
              backgroundColor: 'white', 
              padding: '20px', 
              borderRadius: '20px 20px 0 0', 
              maxWidth: '400px', 
              width: '100%'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Find Genesis User</h3>
            <input
              type="text"
              placeholder="Enter Genesis ID"
              value={searchGenesisID}
              onChange={(e) => setSearchGenesisID(e.target.value)}
              style={{
                width: '100%', 
                padding: '15px', 
                borderRadius: '10px', 
                border: '1px solid #ddd', 
                marginBottom: '15px', 
                fontSize: '16px'
              }}
            />
            <div style={{display: 'flex', gap: '10px'}}>
              <button 
                className="cancel-button" 
                onClick={() => {
                  setShowFindUser(false);
                  setSearchGenesisID('');
                }} 
                style={{flex: 1, padding: '15px'}}
              >
                Cancel
              </button>
              <button 
                className="btn-qr" 
                onClick={searchUserByID} 
                disabled={!searchGenesisID.trim() || uploading}
                style={{flex: 1, padding: '15px'}}
              >
                {uploading ? 'Searching...' : 'Search'}
              </button>
            </div>
          </div>
        </div>
      )}

      {showUserProfile && foundUser && (
        <div 
          className="modal-overlay" 
          style={{
            position: 'fixed', 
            top: 0, 
            left: 0, 
            right: 0, 
            bottom: 0, 
            backgroundColor: 'rgba(0,0,0,0.5)', 
            zIndex: 1000, 
            display: 'flex', 
            alignItems: 'flex-end', 
            justifyContent: 'center'
          }}
          onClick={() => setShowUserProfile(false)}
        >
          <div 
            className="user-profile-modal" 
            style={{
              backgroundColor: 'white', 
              padding: '20px', 
              borderRadius: '20px 20px 0 0', 
              maxWidth: '400px', 
              width: '100%'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Genesis User Profile</h3>
            <p><strong>Genesis ID:</strong> {foundUser.genesisID}</p>
            <p><strong>Name:</strong> {foundUser.firstName} {foundUser.lastName}</p>
            <p><strong>Email:</strong> {foundUser.email}</p>
            {foundUser.location && <p><strong>Location:</strong> {foundUser.location}</p>}
            {foundUser.personalQuote && <p><strong>Quote:</strong> {foundUser.personalQuote}</p>}
            <button className="cancel-button" onClick={() => setShowUserProfile(false)}>
              Close
            </button>
          </div>
        </div>
      )}

{showTransferModal && selectedAsset && (
  <div className="modal-overlay" onClick={closeTransfer}
    style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
    <div className="transfer-modal" onClick={(e) => e.stopPropagation()}
      style={{ backgroundColor: 'white', padding: '20px', borderRadius: '20px 20px 0 0', maxWidth: '400px', width: '100%' }}>
      <h3 style={{ marginTop: 0, marginBottom: '6px' }}>Transfer Asset</h3>
      <p style={{ fontSize: '14px', color: '#64748b', margin: '0 0 14px 0' }}>
        <strong>{selectedAsset.title}</strong>
        {selectedAsset.nftMintAddress && <span style={{ marginLeft: '8px', fontSize: '12px', color: '#16a34a' }}>🪙 NFT · on Solana</span>}
      </p>

      {selectedAsset.nftMintAddress ? (
        nftXferPrep ? (
          <>
            <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '14px', marginBottom: '12px', fontSize: '14px' }}>
              <p style={{ margin: '0 0 8px 0' }}>
                <strong>To:</strong> {nftXferPrep.recipientGenesisID
                  ? `${nftXferPrep.recipientName || 'Genesis user'} (Genesis ID ${nftXferPrep.recipientGenesisID})`
                  : 'External Solana wallet (the asset will leave Genesis)'}
              </p>
              <p style={{ margin: '0 0 8px 0', fontFamily: 'monospace', fontSize: '11px', wordBreak: 'break-all', color: '#555' }}>{nftXferPrep.toWallet}</p>
              <p style={{ margin: 0, fontSize: '12px', color: '#666' }}>
                Network fee: ~0.000005 SOL{nftXferPrep.needsAccount ? ' + 0.00204 SOL (recipient token account)' : ''}
              </p>
            </div>
              {!nftXferPrep.recipientGenesisID && (
              <div style={{ background: '#fff7ed', border: '1px solid #fdba74', borderRadius: '10px', padding: '12px', marginBottom: '12px', fontSize: '13px', color: '#9a3412' }}>
                <p style={{ margin: '0 0 8px 0' }}>
                  ⚠️ Send NFTs only to a <strong>self-custody Solana wallet</strong> (Phantom, Solflare, Genesis TheoWallet).
                  Exchange deposit addresses (Binance, Coinbase, OKX…) do not support NFTs: the NFT may be lost.
                </p>
                <label style={{ display: 'flex', gap: '8px', alignItems: 'flex-start', cursor: 'pointer', color: '#7c2d12' }}>
                  <input type="checkbox" checked={nftXferAck} onChange={(e) => setNftXferAck(e.target.checked)} style={{ marginTop: '2px', flexShrink: 0 }} />
                  <span>I understand. This is my own wallet, not an exchange address.</span>
                </label>
              </div>
            )}
            {nftXferStep && <p style={{ fontSize: '13px', color: '#4f46e5', margin: '0 0 10px 0' }}>⏳ {nftXferStep}</p>}
            {passkeyOn && (
              <>
                <button onClick={() => handleNftTransferConfirm(true)} disabled={nftXferBusy || (!nftXferPrep.recipientGenesisID && !nftXferAck)}
                  style={{ width: '100%', padding: '14px', borderRadius: '10px', border: 'none', background: '#16a34a', color: '#fff', fontWeight: 600, marginBottom: '8px', cursor: 'pointer' }}>
                  {nftXferBusy ? 'Sending...' : '🔐 Confirm with Face ID'}
                </button>
                <p style={{ textAlign: 'center', fontSize: '12px', color: '#888', margin: '0 0 8px 0' }}>or use password</p>
              </>
            )}
            <input type={nftXferShowPw ? 'text' : 'password'} placeholder="Wallet password" value={nftXferPassword}
              onChange={(e) => setNftXferPassword(e.target.value)} disabled={nftXferBusy} autoComplete="current-password"
              style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '8px', boxSizing: 'border-box' }} />
            <button type="button" onClick={() => setNftXferShowPw(!nftXferShowPw)}
              style={{ background: 'none', border: 'none', color: '#4f46e5', fontSize: '13px', cursor: 'pointer', padding: 0, marginBottom: '10px' }}>
              {nftXferShowPw ? '🙈 Hide password' : '👁 Show password'}
            </button>
            {nftXferError && <p style={{ color: '#dc2626', fontSize: '13px', margin: '0 0 10px 0' }}>❌ {nftXferError}</p>}
            <button onClick={() => handleNftTransferConfirm(false)} disabled={nftXferBusy || !nftXferPassword || (!nftXferPrep.recipientGenesisID && !nftXferAck)}
              style={{ width: '100%', padding: '14px', borderRadius: '10px', border: 'none', background: '#1e293b', color: '#fff', marginBottom: '8px', cursor: 'pointer' }}>
              {nftXferBusy ? 'Sending...' : 'Confirm & Send NFT'}
            </button>
            <button onClick={() => { setNftXferPrep(null); setNftXferPassword(''); setNftXferError(''); }} disabled={nftXferBusy}
              className="cancel-button" style={{ width: '100%' }}>Back</button>
          </>
        ) : (
          <>
            <input type="text" placeholder="Recipient Genesis ID or Solana address" value={transferGenesisID}
              onChange={(e) => { setTransferGenesisID(e.target.value); setNftXferError(''); }} disabled={nftXferBusy}
              style={{ width: '100%', padding: '15px', borderRadius: '10px', border: '1px solid #ddd', marginBottom: '12px', fontSize: '14px', boxSizing: 'border-box' }} />
            {nftXferError && <p style={{ color: '#dc2626', fontSize: '13px', margin: '0 0 10px 0' }}>❌ {nftXferError}</p>}
            <button onClick={handleNftTransferPrepare} disabled={!transferGenesisID.trim() || nftXferBusy}
              style={{ width: '100%', padding: '15px', borderRadius: '10px', border: 'none', background: '#1e293b', color: '#fff', marginBottom: '8px', cursor: 'pointer' }}>
              {nftXferBusy ? 'Checking...' : 'Continue'}
            </button>
            <button onClick={closeTransfer} className="cancel-button" style={{ width: '100%' }}>Cancel</button>
          </>
        )
      ) : (
        <>
          <input type="text" placeholder="Recipient Genesis ID" value={transferGenesisID}
            onChange={(e) => setTransferGenesisID(e.target.value)} disabled={transferring}
            style={{ width: '100%', padding: '15px', borderRadius: '10px', border: '1px solid #ddd', marginBottom: '12px', fontSize: '14px', boxSizing: 'border-box' }} />
          <button onClick={transferAsset} disabled={!transferGenesisID.trim() || transferring}
            style={{ width: '100%', padding: '15px', borderRadius: '10px', border: 'none', background: '#1e293b', color: '#fff', marginBottom: '8px', cursor: 'pointer' }}>
            {transferring ? 'Processing...' : 'Transfer to Genesis ID'}
          </button>
          <p style={{ fontSize: '12px', color: '#888', margin: '0 0 8px 0' }}>Tip: mint this asset as an NFT to send it to any Solana wallet.</p>
          <button onClick={closeTransfer} className="cancel-button" style={{ width: '100%' }}>Cancel</button>
        </>
      )}
    </div>
  </div>
)}
    {showCreateWallet && user && (
      <CreateWalletModal
        genesisID={user.genesisID}
        onCreated={handleWalletCreated}
        onClose={() => setShowCreateWallet(false)}
      />
    )}
    {/* ===== FACE ID MODAL ===== */}
    {faceIdStep && (
      <div className="modal-overlay" onClick={faceIdBusy ? undefined : closeFaceId}
        style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
        <div onClick={(e) => e.stopPropagation()}
          style={{ backgroundColor: 'white', padding: '20px', borderRadius: '20px 20px 0 0', maxWidth: '400px', width: '100%' }}>
          <h3 style={{ marginTop: 0 }}>Enable Face ID / fingerprint</h3>

          {faceIdStep === 'password' && (
            <>
              <p style={{ fontSize: '13px', color: '#666', margin: '0 0 10px 0' }}>Enter your wallet password to confirm it's you.</p>
              <input type={faceIdShowPw ? 'text' : 'password'} placeholder="Wallet password" value={faceIdPassword}
                onChange={(e) => setFaceIdPassword(e.target.value)}
                style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '8px', boxSizing: 'border-box' }} />
              <button type="button" onClick={() => setFaceIdShowPw(!faceIdShowPw)}
                style={{ background: 'none', border: 'none', color: '#4f46e5', fontSize: '13px', cursor: 'pointer', padding: 0, marginBottom: '10px' }}>
                {faceIdShowPw ? '🙈 Hide password' : '👁 Show password'}
              </button>
            </>
          )}
          {faceIdStep === 'create' && (
            <p style={{ fontSize: '13px', color: '#666', margin: '0 0 12px 0' }}>
              ✅ Password confirmed. Tap the button below and confirm with Face ID / fingerprint.
            </p>
          )}
          {faceIdStep === 'finish' && (
            <p style={{ fontSize: '13px', color: '#666', margin: '0 0 12px 0' }}>
              One more confirmation is needed on this device. Tap the button and confirm again.
            </p>
          )}

          {faceIdError && <p style={{ color: '#dc2626', fontSize: '13px', margin: '0 0 10px 0' }}>❌ {faceIdError}</p>}

          <button
            onClick={faceIdStep === 'password' ? handleFaceIdPassword : faceIdStep === 'create' ? handleFaceIdCreate : handleFaceIdFinish}
            disabled={faceIdBusy || (faceIdStep === 'password' && !faceIdPassword)}
            style={{ width: '100%', padding: '14px', borderRadius: '10px', border: 'none', background: faceIdStep === 'password' ? '#1e293b' : '#16a34a', color: '#fff', fontWeight: 600, marginBottom: '8px', cursor: 'pointer' }}>
            {faceIdBusy ? 'Please wait...' : faceIdStep === 'password' ? 'Continue' : faceIdStep === 'create' ? '🔐 Enable Face ID' : '🔐 Confirm Face ID'}
          </button>
          <button onClick={closeFaceId} disabled={faceIdBusy} className="cancel-button" style={{ width: '100%' }}>Cancel</button>
        </div>
      </div>
    )}
    {/* ===== END FACE ID MODAL ===== */}
    {/* ===== ASSET MENU ===== */}
    {assetMenu && (() => {
      const a = walletAssetList().find((x) => x.symbol === assetMenu);
      const bal = parseFloat(a.balance);
      const price = tokenPrices[a.symbol];
      const go = (fn) => { setAssetMenu(null); fn(a.symbol); };
      return (
        <div className="modal-overlay" onClick={() => setAssetMenu(null)}
          style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
          <div onClick={(e) => e.stopPropagation()}
            style={{ backgroundColor: 'white', padding: '20px', borderRadius: '20px 20px 0 0', maxWidth: '400px', width: '100%' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
              {assetLogo(a, '44px')}
              <div style={{ flex: 1, textAlign: 'left' }}>
                <div style={{ fontWeight: 700, fontSize: '18px' }}>{a.symbol}</div>
                <div style={{ fontSize: '12px', color: '#888' }}>{a.name}</div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontWeight: 700, fontSize: '18px' }}>{a.balance == null ? '—' : bal.toLocaleString('en-US', { maximumFractionDigits: 6 })}</div>
                <div style={{ fontSize: '12px', color: '#888' }}>{price && !isNaN(bal) ? usd(bal * price) : ''}</div>
              </div>
            </div>
            {price ? (
              <p style={{ fontSize: '12px', color: '#888', margin: '0 0 14px 0' }}>
                1 {a.symbol} ≈ {price < 1 ? `$${price.toPrecision(3)}` : usd(price)}
              </p>
            ) : null}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '10px' }}>
              {[['Receive', openReceive], ['Send', openSend], ['Swap', openSwap], ['History', openHistory]].map(([label, fn]) => (
                <button key={label} onClick={() => go(fn)}
                  style={{ padding: '14px 0', borderRadius: '10px', border: `1px solid ${a.color}`, cursor: 'pointer', fontWeight: 600,
                    background: label === 'Receive' ? a.color : '#fff', color: label === 'Receive' ? '#fff' : a.color }}>
                  {label}
                </button>
              ))}
            </div>
            <button onClick={() => setAssetMenu(null)} className="cancel-button" style={{ width: '100%' }}>Close</button>
          </div>
        </div>
      );
    })()}
    {/* ===== END ASSET MENU ===== */}
    {/* ===== HISTORY MODAL ===== */}
    {historyAsset && (
      <div className="modal-overlay" onClick={closeHistory}
        style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
        <div onClick={(e) => e.stopPropagation()}
          style={{ backgroundColor: 'white', padding: '20px', borderRadius: '20px 20px 0 0', maxWidth: '400px', width: '100%', maxHeight: '85vh', overflowY: 'auto' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
            <h3 style={{ margin: 0 }}>{historyAsset} history</h3>
            <button onClick={closeHistory} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}>×</button>
          </div>

          {historyBusy && <p style={{ color: '#666', fontSize: '14px' }}>Loading transactions...</p>}
          {historyError && <p style={{ color: '#dc2626', fontSize: '13px' }}>❌ {historyError}</p>}

          {!historyBusy && !historyError && (() => {
            const list = historyItems.filter((it) => it.changes.some((c) => c.asset === historyAsset));
            if (list.length === 0) return <p style={{ color: '#999', fontSize: '14px' }}>No {historyAsset} transactions yet</p>;
            return list.map((it) => {
              const icon = it.type === 'Received' ? '↙' : it.type === 'Sent' ? '↗' : '⇄';
              const color = it.type === 'Received' ? '#16a34a' : it.type === 'Sent' ? '#dc2626' : '#2563eb';
              return (
                <div key={it.signature} style={{ borderBottom: '1px solid #eee', padding: '10px 0' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontWeight: 600, color }}>{icon} {it.type}</span>
                    <a href={`https://explorer.solana.com/tx/${it.signature}`} target="_blank" rel="noreferrer" style={{ fontSize: '12px', textDecoration: 'none' }}>🔗</a>
                  </div>
                  <div style={{ fontSize: '14px', margin: '4px 0' }}>
                    {it.changes.map((c) => (
                      <span key={c.asset} style={{ marginRight: '10px', color: parseFloat(c.amount) > 0 ? '#16a34a' : '#dc2626', fontWeight: c.asset === historyAsset ? 700 : 400 }}>
                        {fmtAmount(c.amount)} {c.asset}
                      </span>
                    ))}
                  </div>
                  <div style={{ fontSize: '12px', color: '#888', display: 'flex', justifyContent: 'space-between' }}>
                    <span>{it.counterparty ? (it.type === 'Sent' ? `→ ${shortAddr(it.counterparty)}` : `← ${shortAddr(it.counterparty)}`) : ''}</span>
                    <span>{it.blockTime ? new Date(it.blockTime * 1000).toLocaleString() : ''}</span>
                  </div>
                  {parseFloat(it.fee) > 0 && <div style={{ fontSize: '11px', color: '#aaa' }}>fee {it.fee} SOL</div>}
                </div>
              );
            });
          })()}

          <button onClick={closeHistory} className="cancel-button" style={{ width: '100%', marginTop: '12px' }}>Close</button>
        </div>
      </div>
    )}
    {/* ===== END HISTORY MODAL ===== */}
    {/* ===== SWAP MODAL ===== */}
    {swapFrom && (
      <div className="modal-overlay" onClick={swapBusy ? undefined : closeSwap}
        style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
        <div onClick={(e) => e.stopPropagation()}
          style={{ backgroundColor: 'white', padding: '20px', borderRadius: '20px 20px 0 0', maxWidth: '400px', width: '100%', maxHeight: '90vh', overflowY: 'auto' }}>

          {swapResult ? (
            <>
              <h3 style={{ marginTop: 0 }}>✅ Swapped</h3>
              <p style={{ margin: '0 0 12px 0' }}>
                {swapQuoteData.inAmount} {swapFrom} → ≈ {swapResult.outAmount} {swapTo}
              </p>
              <button onClick={() => window.open(`https://explorer.solana.com/tx/${swapResult.signature}`, '_blank')}
                style={{ width: '100%', padding: '14px', borderRadius: '10px', border: 'none', background: '#9945FF', color: '#fff', marginBottom: '8px', cursor: 'pointer' }}>
                🔗 View on Solana Explorer
              </button>
              <button onClick={closeSwap} className="cancel-button" style={{ width: '100%' }}>Close</button>
            </>
          ) : swapQuoteData ? (() => {
            const q = swapQuoteData;
            const imp = quoteImpact(q);
            const needAck = imp !== null && imp > 15;
            return (
              <>
                <h3 style={{ marginTop: 0 }}>Confirm swap</h3>
                <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '14px', marginBottom: '12px', fontSize: '14px' }}>
                  <p style={{ margin: '0 0 6px 0' }}><strong>You pay:</strong> {q.inAmount} {swapFrom}</p>
                  <p style={{ margin: '0 0 6px 0' }}><strong>You receive ≈</strong> {q.outAmount} {swapTo}</p>
                  <p style={{ margin: '0 0 6px 0', fontSize: '12px', color: '#555' }}>
                    Minimum received: {formatUnits(minOutUnits(q), ASSET_DECIMALS[swapTo])} {swapTo} (slippage {q.slippageBps / 100}%)
                  </p>
                  <p style={{ margin: '0 0 6px 0', fontSize: '12px', color: '#555' }}>
                    Rate: 1 {swapFrom} ≈ {(Number(q.outAmount) / Number(q.inAmount)).toPrecision(6)} {swapTo}
                  </p>
                  <p style={{ margin: '0 0 6px 0', fontSize: '12px', color: impactColor(imp), fontWeight: 600 }}>
                    Price impact: {imp === null ? 'n/a' : `${imp.toFixed(2)}%`}
                    {imp !== null && imp >= 5 ? ' ⚠️ High price impact' : ''}
                  </p>
                  <p style={{ margin: 0, fontSize: '12px', color: '#555' }}>
                    Jupiter fee: {q.feeBps ? `${q.feeBps / 100}%` : '0%'} · Network fee: ~0.00001 SOL (+ ~0.002 SOL if a new token account is needed)
                  </p>
                </div>

                {needAck && (
                  <label style={{ display: 'flex', gap: '8px', alignItems: 'flex-start', fontSize: '13px', color: '#dc2626', marginBottom: '12px', cursor: 'pointer' }}>
                    <input type="checkbox" checked={swapAck} onChange={(e) => setSwapAck(e.target.checked)} />
                    I understand I will receive much less than market price.
                  </label>
                )}
                {passkeyOn && (
                  <>
                    <button onClick={handleSwapFaceId} disabled={swapBusy || (needAck && !swapAck)}
                      style={{ width: '100%', padding: '14px', borderRadius: '10px', border: 'none', background: (needAck && !swapAck) ? '#94a3b8' : '#16a34a', color: '#fff', fontWeight: 600, marginBottom: '8px', cursor: 'pointer' }}>
                      {swapBusy ? 'Swapping...' : '🔐 Confirm with Face ID'}
                    </button>
                    <p style={{ textAlign: 'center', fontSize: '12px', color: '#888', margin: '0 0 8px 0' }}>or use password</p>
                  </>
                )}
                <input type={swapShowPw ? 'text' : 'password'} placeholder="Wallet password" value={swapPassword}
                  onChange={(e) => setSwapPassword(e.target.value)}
                  style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '8px', boxSizing: 'border-box' }} />
                <button type="button" onClick={() => setSwapShowPw(!swapShowPw)}
                  style={{ background: 'none', border: 'none', color: '#4f46e5', fontSize: '13px', cursor: 'pointer', padding: 0, marginBottom: '10px' }}>
                  {swapShowPw ? '🙈 Hide password' : '👁 Show password'}
                </button>

                {swapError && <p style={{ color: '#dc2626', fontSize: '13px', margin: '0 0 10px 0' }}>❌ {swapError}</p>}

                <button onClick={handleSwapConfirm} disabled={swapBusy || !swapPassword || (needAck && !swapAck)}
                  style={{ width: '100%', padding: '14px', borderRadius: '10px', border: 'none', background: (needAck && !swapAck) ? '#94a3b8' : '#1e293b', color: '#fff', marginBottom: '8px', cursor: 'pointer' }}>
                  {swapBusy ? 'Swapping...' : 'Confirm Swap'}
                </button>
                <button onClick={() => { setSwapQuoteData(null); setSwapPassword(''); setSwapError(''); }} disabled={swapBusy}
                  className="cancel-button" style={{ width: '100%' }}>
                  Back
                </button>
              </>
            );
          })() : (
            <>
              <h3 style={{ marginTop: 0 }}>Swap {swapFrom}</h3>
              <p style={{ fontSize: '12px', color: '#666', margin: '0 0 12px 0' }}>
                Available: {parseFloat(assetBalance(swapFrom)).toLocaleString('en-US', { maximumFractionDigits: 6 })} {swapFrom}
              </p>

              <label style={{ fontSize: '12px', color: '#888', display: 'block', marginBottom: '6px' }}>To</label>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '6px', marginBottom: '12px' }}>
                {SWAP_ASSETS.filter((s) => s !== swapFrom).map((s) => (
                  <button key={s} onClick={() => setSwapTo(s)}
                    style={{ padding: '10px 0', borderRadius: '8px', cursor: 'pointer', fontWeight: 600,
                      border: swapTo === s ? '2px solid #1e293b' : '1px solid #ddd',
                      background: swapTo === s ? '#f1f5f9' : '#fff' }}>
                    {s}
                  </button>
                ))}
              </div>

              <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
                <input placeholder={`Amount in ${swapFrom}`} inputMode="decimal" value={swapAmount}
                  onChange={(e) => setSwapAmount(e.target.value)}
                  style={{ flex: 1, padding: '12px', borderRadius: '8px', border: '1px solid #ddd' }} />
                <button onClick={setSwapMax}
                  style={{ padding: '0 16px', borderRadius: '8px', border: '1px solid #ddd', background: '#f5f5f5', cursor: 'pointer' }}>
                  Max
                </button>
              </div>

              {swapError && <p style={{ color: '#dc2626', fontSize: '13px', margin: '0 0 10px 0' }}>❌ {swapError}</p>}

              <button onClick={handleSwapQuote} disabled={swapBusy || !swapAmount}
                style={{ width: '100%', padding: '14px', borderRadius: '10px', border: 'none', background: '#1e293b', color: '#fff', marginBottom: '8px', cursor: 'pointer' }}>
                {swapBusy ? 'Getting quote...' : 'Get quote'}
              </button>
              <button onClick={closeSwap} className="cancel-button" style={{ width: '100%' }}>Cancel</button>
            </>
          )}
        </div>
      </div>
    )}
    {/* ===== END SWAP MODAL ===== */}
        {/* ===== MINT NFT MODAL ===== */}
    {mintAsset && (
      <div className="modal-overlay" onClick={closeMint}
        style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
        <div onClick={(e) => e.stopPropagation()}
          style={{ backgroundColor: 'white', padding: '20px', borderRadius: '20px 20px 0 0', maxWidth: '400px', width: '100%' }}>
          <h3 style={{ marginTop: 0 }}>🪙 Mint NFT</h3>
          <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '14px', marginBottom: '12px', fontSize: '14px' }}>
            <p style={{ margin: '0 0 8px 0' }}><strong>Asset:</strong> {mintAsset.title || mintAsset.assetId}</p>
            <p style={{ margin: '0 0 8px 0' }}><strong>Owner wallet:</strong> {solanaAddress.slice(0, 6)}…{solanaAddress.slice(-6)}</p>
            <p style={{ margin: 0, fontSize: '12px', color: '#666' }}>
              Cost: ~{MINT_MIN_SOL} SOL from your TheoWallet (Solana storage + network fee). Your balance: {parseFloat(solanaBalance).toFixed(4)} SOL
            </p>
          </div>

          {mintStep && <p style={{ fontSize: '13px', color: '#4f46e5', margin: '0 0 10px 0' }}>⏳ {mintStep}</p>}

          {passkeyOn && (
            <>
              <button onClick={() => runMint(true)} disabled={mintBusy}
                style={{ width: '100%', padding: '14px', borderRadius: '10px', border: 'none', background: '#16a34a', color: '#fff', fontWeight: 600, marginBottom: '8px', cursor: 'pointer' }}>
                {mintBusy ? 'Minting...' : '🔐 Confirm with Face ID'}
              </button>
              <p style={{ textAlign: 'center', fontSize: '12px', color: '#888', margin: '0 0 8px 0' }}>or use password</p>
            </>
          )}
          <input type={mintShowPw ? 'text' : 'password'} placeholder="Wallet password" value={mintPassword}
            onChange={(e) => setMintPassword(e.target.value)} disabled={mintBusy}
            style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '8px', boxSizing: 'border-box' }} />
          <button type="button" onClick={() => setMintShowPw(!mintShowPw)}
            style={{ background: 'none', border: 'none', color: '#4f46e5', fontSize: '13px', cursor: 'pointer', padding: 0, marginBottom: '10px' }}>
            {mintShowPw ? '🙈 Hide password' : '👁 Show password'}
          </button>

          {mintError && <p style={{ color: '#dc2626', fontSize: '13px', margin: '0 0 10px 0' }}>❌ {mintError}</p>}

          <button onClick={() => runMint(false)} disabled={mintBusy || !mintPassword}
            style={{ width: '100%', padding: '14px', borderRadius: '10px', border: 'none', background: '#1e293b', color: '#fff', marginBottom: '8px', cursor: 'pointer' }}>
            {mintBusy ? 'Minting...' : 'Confirm & Mint'}
          </button>
          <button onClick={closeMint} disabled={mintBusy} className="cancel-button" style={{ width: '100%' }}>Cancel</button>
        </div>
      </div>
    )}
    {/* ===== END MINT NFT MODAL ===== */}
    {/* ===== SEND MODAL ===== */}
    {sendAsset && (
      <div className="modal-overlay" onClick={sendBusy ? undefined : closeSend}
        style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
        <div onClick={(e) => e.stopPropagation()}
          style={{ backgroundColor: 'white', padding: '20px', borderRadius: '20px 20px 0 0', maxWidth: '400px', width: '100%' }}>

          {sendResult ? (
            <>
              <h3 style={{ marginTop: 0 }}>✅ Sent</h3>
              <p style={{ margin: '0 0 8px 0' }}>
                {sendAmount} {sendAsset} → {sendPrep?.recipientGenesisID
                  ? `${sendPrep.recipientName || 'Genesis user'} (${sendPrep.recipientGenesisID})`
                  : `${sendResult.recipientAddress.slice(0, 6)}…${sendResult.recipientAddress.slice(-6)}`}
              </p>
              <p style={{ fontSize: '12px', color: '#666', margin: '0 0 12px 0' }}>
                Status: {sendResult.status === 'confirmed' ? 'Confirmed' : 'Pending — check the explorer in a minute'}
              </p>
              <button onClick={() => window.open(`https://explorer.solana.com/tx/${sendResult.signature}`, '_blank')}
                style={{ width: '100%', padding: '14px', borderRadius: '10px', border: 'none', background: '#9945FF', color: '#fff', marginBottom: '8px', cursor: 'pointer' }}>
                🔗 View on Solana Explorer
              </button>
              <button onClick={closeSend} className="cancel-button" style={{ width: '100%' }}>Close</button>
            </>
          ) : sendPrep ? (
            <>
              <h3 style={{ marginTop: 0 }}>Confirm transfer</h3>
              <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '14px', marginBottom: '12px', fontSize: '14px' }}>
                <p style={{ margin: '0 0 8px 0' }}><strong>Amount:</strong> {sendAmount} {sendAsset}</p>
                <p style={{ margin: '0 0 8px 0' }}>
                  <strong>To:</strong> {sendPrep.recipientGenesisID
                    ? `${sendPrep.recipientName || 'Genesis user'} (Genesis ID ${sendPrep.recipientGenesisID})`
                    : 'External Solana wallet'}
                </p>
                <p style={{ margin: '0 0 8px 0', fontFamily: 'monospace', fontSize: '11px', wordBreak: 'break-all', color: '#555' }}>
                  {sendPrep.recipientAddress}
                </p>
                <p style={{ margin: 0, fontSize: '12px', color: '#666' }}>
                  Network fee: ~0.000005 SOL{sendPrep.needsAccount ? ' + 0.00204 SOL (recipient token account)' : ''}
                </p>
              </div>
              {passkeyOn && (
                <>
                  <button onClick={handleSendFaceId} disabled={sendBusy}
                    style={{ width: '100%', padding: '14px', borderRadius: '10px', border: 'none', background: '#16a34a', color: '#fff', fontWeight: 600, marginBottom: '8px', cursor: 'pointer' }}>
                    {sendBusy ? 'Sending...' : '🔐 Confirm with Face ID'}
                  </button>
                  <p style={{ textAlign: 'center', fontSize: '12px', color: '#888', margin: '0 0 8px 0' }}>or use password</p>
                </>
              )}
              <input type={sendShowPw ? 'text' : 'password'} placeholder="Wallet password" value={sendPassword}
                onChange={(e) => setSendPassword(e.target.value)}
                style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '8px', boxSizing: 'border-box' }} />
              <button type="button" onClick={() => setSendShowPw(!sendShowPw)}
                style={{ background: 'none', border: 'none', color: '#4f46e5', fontSize: '13px', cursor: 'pointer', padding: 0, marginBottom: '10px' }}>
                {sendShowPw ? '🙈 Hide password' : '👁 Show password'}
              </button>

              {sendError && <p style={{ color: '#dc2626', fontSize: '13px', margin: '0 0 10px 0' }}>❌ {sendError}</p>}

              <button onClick={handleSendConfirm} disabled={sendBusy || !sendPassword}
                style={{ width: '100%', padding: '14px', borderRadius: '10px', border: 'none', background: '#1e293b', color: '#fff', marginBottom: '8px', cursor: 'pointer' }}>
                {sendBusy ? 'Sending...' : 'Confirm & Send'}
              </button>
              <button onClick={() => { setSendPrep(null); setSendPassword(''); setSendError(''); }} disabled={sendBusy}
                className="cancel-button" style={{ width: '100%' }}>
                Back
              </button>
            </>
          ) : (
            <>
              <h3 style={{ marginTop: 0 }}>Send {sendAsset}</h3>
              <p style={{ fontSize: '12px', color: '#666', margin: '0 0 12px 0' }}>
                Available: {parseFloat(assetBalance(sendAsset)).toLocaleString('en-US', { maximumFractionDigits: 6 })} {sendAsset}
              </p>
              <input placeholder="Genesis ID or Solana address" value={sendTo}
                onChange={(e) => setSendTo(e.target.value)}
                style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '10px', boxSizing: 'border-box' }} />
              <div style={{ display: 'flex', gap: '8px', marginBottom: '10px' }}>
                <input placeholder="Amount" inputMode="decimal" value={sendAmount}
                  onChange={(e) => setSendAmount(e.target.value)}
                  style={{ flex: 1, padding: '12px', borderRadius: '8px', border: '1px solid #ddd' }} />
                <button onClick={setMaxAmount}
                  style={{ padding: '0 16px', borderRadius: '8px', border: '1px solid #ddd', background: '#f5f5f5', cursor: 'pointer' }}>
                  Max
                </button>
              </div>
              <p style={{ fontSize: '12px', color: '#dc2626', margin: '0 0 10px 0' }}>Solana network only.</p>

              {sendError && <p style={{ color: '#dc2626', fontSize: '13px', margin: '0 0 10px 0' }}>❌ {sendError}</p>}

              <button onClick={handleSendNext} disabled={sendBusy || !sendTo.trim() || !sendAmount}
                style={{ width: '100%', padding: '14px', borderRadius: '10px', border: 'none', background: '#1e293b', color: '#fff', marginBottom: '8px', cursor: 'pointer' }}>
                {sendBusy ? 'Checking...' : 'Next'}
              </button>
              <button onClick={closeSend} className="cancel-button" style={{ width: '100%' }}>Cancel</button>
            </>
          )}
        </div>
      </div>
    )}
    {/* ===== END SEND MODAL ===== */}
    {/* ===== SECURITY MODAL ===== */}
    {securityModal && (
      <div className="modal-overlay" onClick={closeSecurityModal}
        style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
        <div onClick={(e) => e.stopPropagation()}
          style={{ backgroundColor: 'white', padding: '20px', borderRadius: '20px 20px 0 0', maxWidth: '400px', width: '100%' }}>
          <h3 style={{ marginTop: 0 }}>
            {securityModal === 'protect' ? 'Protect wallet' : securityModal === 'import' ? 'Import backup' : 'Export backup'}
          </h3>

          {securityModal === 'import' && (
            <>
              <input type="file" accept=".txt" onChange={handleBackupFile} style={{ marginBottom: '10px' }} />
              <textarea
                placeholder="...or paste the backup text here"
                value={secBackupText}
                onChange={(e) => setSecBackupText(e.target.value)}
                rows={4}
                style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '12px', marginBottom: '10px', boxSizing: 'border-box' }}
              />
            </>
          )}

          <input type={secShowPw ? 'text' : 'password'} placeholder="Password (8+ letters and digits)" value={secPassword}
            onChange={(e) => setSecPassword(e.target.value)}
            style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '10px', boxSizing: 'border-box' }} />

          {securityModal !== 'export' && (
            <>
              <input type={secShowPw ? 'text' : 'password'} placeholder="Repeat password" value={secPassword2}
                onChange={(e) => setSecPassword2(e.target.value)}
                style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ddd', marginBottom: '10px', boxSizing: 'border-box' }} />
              <p style={{ fontSize: '12px', color: '#dc2626', margin: '0 0 10px 0' }}>
                If you forget this password, the only way to restore your wallet is your .txt backup file.
              </p>
            </>
          )}
          <button
            type="button"
            onClick={() => setSecShowPw(!secShowPw)}
            style={{ background: 'none', border: 'none', color: '#4f46e5', fontSize: '13px', cursor: 'pointer', padding: 0, marginBottom: '10px' }}
          >
            {secShowPw ? '🙈 Hide password' : '👁 Show password'}
          </button>
          {secError && <p style={{ color: '#dc2626', fontSize: '13px', margin: '0 0 10px 0' }}>❌ {secError}</p>}

          <button
            onClick={securityModal === 'export' ? handleExportBackup : handleProtectOrImport}
            disabled={secBusy}
            style={{ width: '100%', padding: '14px', borderRadius: '10px', border: 'none', background: '#1e293b', color: '#fff', marginBottom: '8px', cursor: 'pointer' }}>
            {secBusy ? 'Processing...' : 'Confirm'}
          </button>
          <button onClick={closeSecurityModal} className="cancel-button" style={{ width: '100%' }}>
            Cancel
          </button>
        </div>
      </div>
    )}
    {/* ===== END SECURITY MODAL ===== */}    
        {/* ===== RECEIVE MODAL ===== */}
    {receiveQR && (
      <div
        className="modal-overlay"
        onClick={() => { setReceiveQR(null); setReceiveAsset(null); }}
        style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{ backgroundColor: 'white', padding: '20px', borderRadius: '20px 20px 0 0', maxWidth: '400px', width: '100%', textAlign: 'center' }}
        >
          <h3>Receive {receiveAsset}</h3>
          <img src={receiveQR} alt="Receive QR" style={{ maxWidth: '220px', margin: '10px 0' }} />
          <p style={{ fontFamily: 'monospace', fontSize: '12px', wordBreak: 'break-all' }}>{solanaAddress}</p>
          <p style={{ fontSize: '12px', color: '#dc2626', margin: '10px 0' }}>
            Send only {receiveAsset} on the Solana network to this address.
          </p>
          <button
            className="btn-asset"
            style={{ width: '100%', marginBottom: '8px' }}
            onClick={() => { navigator.clipboard.writeText(solanaAddress); alert('Address copied!'); }}
          >
            Copy Address
          </button>
          <button
            className="cancel-button"
            style={{ width: '100%' }}
            onClick={() => { setReceiveQR(null); setReceiveAsset(null); }}
          >
            Close
          </button>
        </div>
      </div>
    )}
    {/* ===== END RECEIVE MODAL ===== */}

    {/* CERTIFICATE MODAL */}
{certificateModal && (
  <div className="modal-overlay"
    style={{ position:'fixed', top:0, left:0, right:0, bottom:0,
      backgroundColor:'rgba(0,0,0,0.7)', zIndex:1000,
      display:'flex', alignItems:'flex-end', justifyContent:'center' }}
    onClick={() => setCertificateModal(null)}>
    <div style={{ backgroundColor:'white', padding:'24px',
      borderRadius:'20px 20px 0 0', maxWidth:'480px', width:'100%',
      maxHeight:'85vh', overflowY:'auto' }}
      onClick={e => e.stopPropagation()}>

      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'16px' }}>
        <h3 style={{ margin:0, fontSize:'18px' }}>📄 Asset Certificate</h3>
        <button onClick={() => setCertificateModal(null)}
          style={{ background:'none', border:'none', fontSize:'24px', cursor:'pointer' }}>×</button>
      </div>

      {certificateModal.fromCache && (
        <div style={{ background:'#f0fdf4', border:'1px solid #86efac',
          borderRadius:'8px', padding:'10px 14px', marginBottom:'14px',
          fontSize:'13px', color:'#166534' }}>
          ✅ Certificate already generated — loaded from cache
        </div>
      )}

      <div style={{ background:'#f8fafc', borderRadius:'12px',
        padding:'16px', marginBottom:'16px', fontSize:'13px' }}>
        <div style={{ marginBottom:'10px' }}>
          <span style={{ color:'#888', fontSize:'11px', fontWeight:'600',
            textTransform:'uppercase' }}>Solana TX</span>
          <div style={{ fontFamily:'monospace', fontSize:'11px',
            wordBreak:'break-all', marginTop:'4px', color:'#1a1a1a' }}>
            {certificateModal.solanaTxHash || 'N/A'}
          </div>
        </div>
        {certificateModal.ipfsCid && (
          <div style={{ marginBottom:'10px' }}>
            <span style={{ color:'#888', fontSize:'11px', fontWeight:'600',
              textTransform:'uppercase' }}>IPFS CID</span>
            <div style={{ fontFamily:'monospace', fontSize:'11px',
              wordBreak:'break-all', marginTop:'4px', color:'#1a1a1a' }}>
              {certificateModal.ipfsCid}
            </div>
          </div>
        )}
        {certificateModal.fileHash && (
          <div>
            <span style={{ color:'#888', fontSize:'11px', fontWeight:'600',
              textTransform:'uppercase' }}>SHA-256</span>
            <div style={{ fontFamily:'monospace', fontSize:'11px',
              wordBreak:'break-all', marginTop:'4px', color:'#1a1a1a' }}>
              {certificateModal.fileHash}
            </div>
          </div>
        )}
      </div>

      <div style={{ display:'flex', flexDirection:'column', gap:'10px' }}>
        <button
          onClick={() => window.open(certificateModal.url, '_blank')}
          style={{ padding:'14px', background:'#0a0a0a', color:'white',
            border:'none', borderRadius:'12px', fontSize:'15px',
            fontWeight:'600', cursor:'pointer' }}>
          📄 Open PDF Certificate
        </button>
        {certificateModal.solanaTxHash && certificateModal.solanaTxHash !== 'pending' && (
          <button
            onClick={() => window.open(`https://explorer.solana.com/tx/${certificateModal.solanaTxHash}`, '_blank')}
            style={{ padding:'14px', background:'#9945FF', color:'white',
              border:'none', borderRadius:'12px', fontSize:'15px',
              fontWeight:'600', cursor:'pointer' }}>
            🔗 View on Solana Explorer
          </button>
        )}
        {certificateModal.ipfsCid && (
          <button
            onClick={() => window.open(`https://gateway.pinata.cloud/ipfs/${certificateModal.ipfsCid}`, '_blank')}
            style={{ padding:'14px', background:'#e8750a', color:'white',
              border:'none', borderRadius:'12px', fontSize:'15px',
              fontWeight:'600', cursor:'pointer' }}>
            🌐 View on IPFS
          </button>
        )}
        <button
          onClick={() => setCertificateModal(null)}
          style={{ padding:'14px', background:'#f5f5f5', color:'#333',
            border:'none', borderRadius:'12px', fontSize:'15px', cursor:'pointer' }}>
          Close
        </button>
      </div>
    </div>
  </div>
)}
    </div>
  );
}

export default ProfilePage;
